// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/admin_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Family, FamilyStatus, RematchSession, RematchSessionStatus } from "./advisors_service_pb.ts";
import { AccountStub, Advisor, AdvisorStatus, Attachment, PlanUtilization, UploadAttachment, UserPermission } from "./common_pb.ts";
import { AdvisorAnnotation, AdvisorChangeEventAnnotation } from "./annotations_pb.ts";

/**
 * @generated from enum protogen.FamilyDirectoryMapLocationType
 */
export enum FamilyDirectoryMapLocationType {
  /**
   * @generated from enum value: FAMILY_DIRECTORY_MAP_LOCATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FAMILY_DIRECTORY_MAP_LOCATION_TYPE_FAMILY = 1;
   */
  FAMILY = 1,

  /**
   * @generated from enum value: FAMILY_DIRECTORY_MAP_LOCATION_TYPE_ADVISOR = 2;
   */
  ADVISOR = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(FamilyDirectoryMapLocationType)
proto3.util.setEnumType(FamilyDirectoryMapLocationType, "protogen.FamilyDirectoryMapLocationType", [
  { no: 0, name: "FAMILY_DIRECTORY_MAP_LOCATION_TYPE_UNSPECIFIED" },
  { no: 1, name: "FAMILY_DIRECTORY_MAP_LOCATION_TYPE_FAMILY" },
  { no: 2, name: "FAMILY_DIRECTORY_MAP_LOCATION_TYPE_ADVISOR" },
]);

/**
 * @generated from message protogen.ListAllFamiliesRequest
 */
export class ListAllFamiliesRequest extends Message<ListAllFamiliesRequest> {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  /**
   * @generated from field: protogen.FamilyStatus status = 3;
   */
  status = FamilyStatus.NOT_SET;

  /**
   * @generated from field: string advisorRef = 4;
   */
  advisorRef = "";

  /**
   * @generated from field: int32 marketCode = 5;
   */
  marketCode = 0;

  /**
   * @generated from field: string query = 6;
   */
  query = "";

  constructor(data?: PartialMessage<ListAllFamiliesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAllFamiliesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(FamilyStatus) },
    { no: 4, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "marketCode", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAllFamiliesRequest {
    return new ListAllFamiliesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAllFamiliesRequest {
    return new ListAllFamiliesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAllFamiliesRequest {
    return new ListAllFamiliesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAllFamiliesRequest | PlainMessage<ListAllFamiliesRequest> | undefined, b: ListAllFamiliesRequest | PlainMessage<ListAllFamiliesRequest> | undefined): boolean {
    return proto3.util.equals(ListAllFamiliesRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAllFamiliesResponse
 */
export class ListAllFamiliesResponse extends Message<ListAllFamiliesResponse> {
  /**
   * @generated from field: repeated protogen.Family families = 1;
   */
  families: Family[] = [];

  /**
   * @generated from field: repeated protogen.ListAllFamiliesResponse.FamilyPermissions familyPermissions = 2;
   */
  familyPermissions: ListAllFamiliesResponse_FamilyPermissions[] = [];

  /**
   * @generated from field: string nextCursor = 3;
   */
  nextCursor = "";

  /**
   * @generated from field: repeated protogen.FamilyDirectoryMarket markets = 4;
   */
  markets: FamilyDirectoryMarket[] = [];

  /**
   * @generated from field: repeated protogen.AccountStub primaryAdvisors = 5;
   */
  primaryAdvisors: AccountStub[] = [];

  constructor(data?: PartialMessage<ListAllFamiliesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAllFamiliesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "families", kind: "message", T: Family, repeated: true },
    { no: 2, name: "familyPermissions", kind: "message", T: ListAllFamiliesResponse_FamilyPermissions, repeated: true },
    { no: 3, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "markets", kind: "message", T: FamilyDirectoryMarket, repeated: true },
    { no: 5, name: "primaryAdvisors", kind: "message", T: AccountStub, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAllFamiliesResponse {
    return new ListAllFamiliesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAllFamiliesResponse {
    return new ListAllFamiliesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAllFamiliesResponse {
    return new ListAllFamiliesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAllFamiliesResponse | PlainMessage<ListAllFamiliesResponse> | undefined, b: ListAllFamiliesResponse | PlainMessage<ListAllFamiliesResponse> | undefined): boolean {
    return proto3.util.equals(ListAllFamiliesResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAllFamiliesResponse.FamilyPermissions
 */
export class ListAllFamiliesResponse_FamilyPermissions extends Message<ListAllFamiliesResponse_FamilyPermissions> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * @generated from field: protogen.AccountStub primaryAdvisor = 2;
   */
  primaryAdvisor?: AccountStub;

  /**
   * @generated from field: repeated protogen.UserPermission advisorPermissions = 3;
   */
  advisorPermissions: UserPermission[] = [];

  constructor(data?: PartialMessage<ListAllFamiliesResponse_FamilyPermissions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAllFamiliesResponse.FamilyPermissions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "primaryAdvisor", kind: "message", T: AccountStub },
    { no: 3, name: "advisorPermissions", kind: "message", T: UserPermission, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAllFamiliesResponse_FamilyPermissions {
    return new ListAllFamiliesResponse_FamilyPermissions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAllFamiliesResponse_FamilyPermissions {
    return new ListAllFamiliesResponse_FamilyPermissions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAllFamiliesResponse_FamilyPermissions {
    return new ListAllFamiliesResponse_FamilyPermissions().fromJsonString(jsonString, options);
  }

  static equals(a: ListAllFamiliesResponse_FamilyPermissions | PlainMessage<ListAllFamiliesResponse_FamilyPermissions> | undefined, b: ListAllFamiliesResponse_FamilyPermissions | PlainMessage<ListAllFamiliesResponse_FamilyPermissions> | undefined): boolean {
    return proto3.util.equals(ListAllFamiliesResponse_FamilyPermissions, a, b);
  }
}

/**
 * @generated from message protogen.FamilyDirectoryMarket
 */
export class FamilyDirectoryMarket extends Message<FamilyDirectoryMarket> {
  /**
   * @generated from field: int32 code = 1;
   */
  code = 0;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<FamilyDirectoryMarket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FamilyDirectoryMarket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FamilyDirectoryMarket {
    return new FamilyDirectoryMarket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FamilyDirectoryMarket {
    return new FamilyDirectoryMarket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FamilyDirectoryMarket {
    return new FamilyDirectoryMarket().fromJsonString(jsonString, options);
  }

  static equals(a: FamilyDirectoryMarket | PlainMessage<FamilyDirectoryMarket> | undefined, b: FamilyDirectoryMarket | PlainMessage<FamilyDirectoryMarket> | undefined): boolean {
    return proto3.util.equals(FamilyDirectoryMarket, a, b);
  }
}

/**
 * @generated from message protogen.FamilyDirectoryMapLocation
 */
export class FamilyDirectoryMapLocation extends Message<FamilyDirectoryMapLocation> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string formattedAddress = 3;
   */
  formattedAddress = "";

  /**
   * @generated from field: double latitude = 4;
   */
  latitude = 0;

  /**
   * @generated from field: double longitude = 5;
   */
  longitude = 0;

  /**
   * @generated from field: protogen.FamilyStatus familyStatus = 6;
   */
  familyStatus = FamilyStatus.NOT_SET;

  /**
   * @generated from field: protogen.FamilyDirectoryMapLocationType type = 7;
   */
  type = FamilyDirectoryMapLocationType.UNSPECIFIED;

  /**
   * @generated from field: protogen.AdvisorStatus advisorStatus = 8;
   */
  advisorStatus = AdvisorStatus.NOT_SET;

  constructor(data?: PartialMessage<FamilyDirectoryMapLocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FamilyDirectoryMapLocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "formattedAddress", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "latitude", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "longitude", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "familyStatus", kind: "enum", T: proto3.getEnumType(FamilyStatus) },
    { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(FamilyDirectoryMapLocationType) },
    { no: 8, name: "advisorStatus", kind: "enum", T: proto3.getEnumType(AdvisorStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FamilyDirectoryMapLocation {
    return new FamilyDirectoryMapLocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FamilyDirectoryMapLocation {
    return new FamilyDirectoryMapLocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FamilyDirectoryMapLocation {
    return new FamilyDirectoryMapLocation().fromJsonString(jsonString, options);
  }

  static equals(a: FamilyDirectoryMapLocation | PlainMessage<FamilyDirectoryMapLocation> | undefined, b: FamilyDirectoryMapLocation | PlainMessage<FamilyDirectoryMapLocation> | undefined): boolean {
    return proto3.util.equals(FamilyDirectoryMapLocation, a, b);
  }
}

/**
 * @generated from message protogen.ListFamilyDirectoryMapLocationsRequest
 */
export class ListFamilyDirectoryMapLocationsRequest extends Message<ListFamilyDirectoryMapLocationsRequest> {
  /**
   * @generated from field: protogen.FamilyStatus status = 1;
   */
  status = FamilyStatus.NOT_SET;

  /**
   * @generated from field: string advisorRef = 2;
   */
  advisorRef = "";

  /**
   * @generated from field: int32 marketCode = 3;
   */
  marketCode = 0;

  /**
   * @generated from field: string query = 4;
   */
  query = "";

  constructor(data?: PartialMessage<ListFamilyDirectoryMapLocationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFamilyDirectoryMapLocationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(FamilyStatus) },
    { no: 2, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "marketCode", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFamilyDirectoryMapLocationsRequest {
    return new ListFamilyDirectoryMapLocationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFamilyDirectoryMapLocationsRequest {
    return new ListFamilyDirectoryMapLocationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFamilyDirectoryMapLocationsRequest {
    return new ListFamilyDirectoryMapLocationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFamilyDirectoryMapLocationsRequest | PlainMessage<ListFamilyDirectoryMapLocationsRequest> | undefined, b: ListFamilyDirectoryMapLocationsRequest | PlainMessage<ListFamilyDirectoryMapLocationsRequest> | undefined): boolean {
    return proto3.util.equals(ListFamilyDirectoryMapLocationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListFamilyDirectoryMapLocationsResponse
 */
export class ListFamilyDirectoryMapLocationsResponse extends Message<ListFamilyDirectoryMapLocationsResponse> {
  /**
   * @generated from field: repeated protogen.FamilyDirectoryMapLocation locations = 1;
   */
  locations: FamilyDirectoryMapLocation[] = [];

  constructor(data?: PartialMessage<ListFamilyDirectoryMapLocationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFamilyDirectoryMapLocationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locations", kind: "message", T: FamilyDirectoryMapLocation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFamilyDirectoryMapLocationsResponse {
    return new ListFamilyDirectoryMapLocationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFamilyDirectoryMapLocationsResponse {
    return new ListFamilyDirectoryMapLocationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFamilyDirectoryMapLocationsResponse {
    return new ListFamilyDirectoryMapLocationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFamilyDirectoryMapLocationsResponse | PlainMessage<ListFamilyDirectoryMapLocationsResponse> | undefined, b: ListFamilyDirectoryMapLocationsResponse | PlainMessage<ListFamilyDirectoryMapLocationsResponse> | undefined): boolean {
    return proto3.util.equals(ListFamilyDirectoryMapLocationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminListAllAdvisorsRequest
 */
export class AdminListAllAdvisorsRequest extends Message<AdminListAllAdvisorsRequest> {
  /**
   * @generated from field: repeated string advisorRefs = 1;
   */
  advisorRefs: string[] = [];

  constructor(data?: PartialMessage<AdminListAllAdvisorsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminListAllAdvisorsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminListAllAdvisorsRequest {
    return new AdminListAllAdvisorsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminListAllAdvisorsRequest {
    return new AdminListAllAdvisorsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminListAllAdvisorsRequest {
    return new AdminListAllAdvisorsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminListAllAdvisorsRequest | PlainMessage<AdminListAllAdvisorsRequest> | undefined, b: AdminListAllAdvisorsRequest | PlainMessage<AdminListAllAdvisorsRequest> | undefined): boolean {
    return proto3.util.equals(AdminListAllAdvisorsRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminListAllAdvisorsResponse
 */
export class AdminListAllAdvisorsResponse extends Message<AdminListAllAdvisorsResponse> {
  /**
   * @generated from field: repeated protogen.Advisor advisors = 1;
   */
  advisors: Advisor[] = [];

  constructor(data?: PartialMessage<AdminListAllAdvisorsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminListAllAdvisorsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisors", kind: "message", T: Advisor, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminListAllAdvisorsResponse {
    return new AdminListAllAdvisorsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminListAllAdvisorsResponse {
    return new AdminListAllAdvisorsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminListAllAdvisorsResponse {
    return new AdminListAllAdvisorsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminListAllAdvisorsResponse | PlainMessage<AdminListAllAdvisorsResponse> | undefined, b: AdminListAllAdvisorsResponse | PlainMessage<AdminListAllAdvisorsResponse> | undefined): boolean {
    return proto3.util.equals(AdminListAllAdvisorsResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdvisorAdministrationFamily
 */
export class AdvisorAdministrationFamily extends Message<AdvisorAdministrationFamily> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: protogen.FamilyStatus status = 3;
   */
  status = FamilyStatus.NOT_SET;

  /**
   * @generated from field: bool isPaused = 4;
   */
  isPaused = false;

  constructor(data?: PartialMessage<AdvisorAdministrationFamily>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdvisorAdministrationFamily";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(FamilyStatus) },
    { no: 4, name: "isPaused", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdvisorAdministrationFamily {
    return new AdvisorAdministrationFamily().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdvisorAdministrationFamily {
    return new AdvisorAdministrationFamily().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdvisorAdministrationFamily {
    return new AdvisorAdministrationFamily().fromJsonString(jsonString, options);
  }

  static equals(a: AdvisorAdministrationFamily | PlainMessage<AdvisorAdministrationFamily> | undefined, b: AdvisorAdministrationFamily | PlainMessage<AdvisorAdministrationFamily> | undefined): boolean {
    return proto3.util.equals(AdvisorAdministrationFamily, a, b);
  }
}

/**
 * @generated from message protogen.AdvisorAdministrationFamilies
 */
export class AdvisorAdministrationFamilies extends Message<AdvisorAdministrationFamilies> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  /**
   * @generated from field: repeated protogen.AdvisorAdministrationFamily families = 2;
   */
  families: AdvisorAdministrationFamily[] = [];

  constructor(data?: PartialMessage<AdvisorAdministrationFamilies>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdvisorAdministrationFamilies";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "families", kind: "message", T: AdvisorAdministrationFamily, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdvisorAdministrationFamilies {
    return new AdvisorAdministrationFamilies().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdvisorAdministrationFamilies {
    return new AdvisorAdministrationFamilies().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdvisorAdministrationFamilies {
    return new AdvisorAdministrationFamilies().fromJsonString(jsonString, options);
  }

  static equals(a: AdvisorAdministrationFamilies | PlainMessage<AdvisorAdministrationFamilies> | undefined, b: AdvisorAdministrationFamilies | PlainMessage<AdvisorAdministrationFamilies> | undefined): boolean {
    return proto3.util.equals(AdvisorAdministrationFamilies, a, b);
  }
}

/**
 * @generated from message protogen.ListAdvisorAdministrationRequest
 */
export class ListAdvisorAdministrationRequest extends Message<ListAdvisorAdministrationRequest> {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  /**
   * @generated from field: string query = 3;
   */
  query = "";

  /**
   * @generated from field: string advisorRef = 4;
   */
  advisorRef = "";

  /**
   * @generated from field: protogen.AdvisorStatus status = 5;
   */
  status = AdvisorStatus.NOT_SET;

  /**
   * @generated from field: int32 marketCode = 6;
   */
  marketCode = 0;

  constructor(data?: PartialMessage<ListAdvisorAdministrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorAdministrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(AdvisorStatus) },
    { no: 6, name: "marketCode", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorAdministrationRequest {
    return new ListAdvisorAdministrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationRequest {
    return new ListAdvisorAdministrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationRequest {
    return new ListAdvisorAdministrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorAdministrationRequest | PlainMessage<ListAdvisorAdministrationRequest> | undefined, b: ListAdvisorAdministrationRequest | PlainMessage<ListAdvisorAdministrationRequest> | undefined): boolean {
    return proto3.util.equals(ListAdvisorAdministrationRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAdvisorAdministrationResponse
 */
export class ListAdvisorAdministrationResponse extends Message<ListAdvisorAdministrationResponse> {
  /**
   * @generated from field: repeated protogen.Advisor advisors = 1;
   */
  advisors: Advisor[] = [];

  /**
   * @generated from field: repeated protogen.AdvisorAdministrationFamilies advisorFamilies = 2;
   */
  advisorFamilies: AdvisorAdministrationFamilies[] = [];

  /**
   * @generated from field: string nextCursor = 3;
   */
  nextCursor = "";

  /**
   * @generated from field: repeated protogen.FamilyDirectoryMarket markets = 4;
   */
  markets: FamilyDirectoryMarket[] = [];

  constructor(data?: PartialMessage<ListAdvisorAdministrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorAdministrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisors", kind: "message", T: Advisor, repeated: true },
    { no: 2, name: "advisorFamilies", kind: "message", T: AdvisorAdministrationFamilies, repeated: true },
    { no: 3, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "markets", kind: "message", T: FamilyDirectoryMarket, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorAdministrationResponse {
    return new ListAdvisorAdministrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationResponse {
    return new ListAdvisorAdministrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationResponse {
    return new ListAdvisorAdministrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorAdministrationResponse | PlainMessage<ListAdvisorAdministrationResponse> | undefined, b: ListAdvisorAdministrationResponse | PlainMessage<ListAdvisorAdministrationResponse> | undefined): boolean {
    return proto3.util.equals(ListAdvisorAdministrationResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAdvisorAdministrationMapLocationsRequest
 */
export class ListAdvisorAdministrationMapLocationsRequest extends Message<ListAdvisorAdministrationMapLocationsRequest> {
  /**
   * @generated from field: string query = 1;
   */
  query = "";

  /**
   * @generated from field: protogen.AdvisorStatus status = 2;
   */
  status = AdvisorStatus.NOT_SET;

  /**
   * @generated from field: int32 marketCode = 3;
   */
  marketCode = 0;

  constructor(data?: PartialMessage<ListAdvisorAdministrationMapLocationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorAdministrationMapLocationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(AdvisorStatus) },
    { no: 3, name: "marketCode", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorAdministrationMapLocationsRequest {
    return new ListAdvisorAdministrationMapLocationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationMapLocationsRequest {
    return new ListAdvisorAdministrationMapLocationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationMapLocationsRequest {
    return new ListAdvisorAdministrationMapLocationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorAdministrationMapLocationsRequest | PlainMessage<ListAdvisorAdministrationMapLocationsRequest> | undefined, b: ListAdvisorAdministrationMapLocationsRequest | PlainMessage<ListAdvisorAdministrationMapLocationsRequest> | undefined): boolean {
    return proto3.util.equals(ListAdvisorAdministrationMapLocationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAdvisorAdministrationMapLocationsResponse
 */
export class ListAdvisorAdministrationMapLocationsResponse extends Message<ListAdvisorAdministrationMapLocationsResponse> {
  /**
   * @generated from field: repeated protogen.FamilyDirectoryMapLocation locations = 1;
   */
  locations: FamilyDirectoryMapLocation[] = [];

  constructor(data?: PartialMessage<ListAdvisorAdministrationMapLocationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorAdministrationMapLocationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locations", kind: "message", T: FamilyDirectoryMapLocation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorAdministrationMapLocationsResponse {
    return new ListAdvisorAdministrationMapLocationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationMapLocationsResponse {
    return new ListAdvisorAdministrationMapLocationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorAdministrationMapLocationsResponse {
    return new ListAdvisorAdministrationMapLocationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorAdministrationMapLocationsResponse | PlainMessage<ListAdvisorAdministrationMapLocationsResponse> | undefined, b: ListAdvisorAdministrationMapLocationsResponse | PlainMessage<ListAdvisorAdministrationMapLocationsResponse> | undefined): boolean {
    return proto3.util.equals(ListAdvisorAdministrationMapLocationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateAdvisorRequest
 */
export class CreateAdvisorRequest extends Message<CreateAdvisorRequest> {
  /**
   * Details
   *
   * @generated from field: string firstName = 1;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 2;
   */
  lastName = "";

  /**
   * Contact.
   *
   * @generated from field: string personalPhone = 3;
   */
  personalPhone = "";

  /**
   * @generated from field: string personalEmail = 4;
   */
  personalEmail = "";

  /**
   * Assigned details.
   *
   * @generated from field: string username = 5;
   */
  username = "";

  /**
   * @generated from field: string advisorPhone = 6;
   */
  advisorPhone = "";

  /**
   * @generated from field: bool sendIntroEmail = 7;
   */
  sendIntroEmail = false;

  /**
   * @generated from field: string timezone = 8;
   */
  timezone = "";

  /**
   * @generated from field: protogen.AdvisorStatus status = 9;
   */
  status = AdvisorStatus.NOT_SET;

  /**
   * @generated from field: string address = 10;
   */
  address = "";

  constructor(data?: PartialMessage<CreateAdvisorRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateAdvisorRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "personalPhone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "personalEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "advisorPhone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sendIntroEmail", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(AdvisorStatus) },
    { no: 10, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdvisorRequest {
    return new CreateAdvisorRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdvisorRequest {
    return new CreateAdvisorRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdvisorRequest {
    return new CreateAdvisorRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdvisorRequest | PlainMessage<CreateAdvisorRequest> | undefined, b: CreateAdvisorRequest | PlainMessage<CreateAdvisorRequest> | undefined): boolean {
    return proto3.util.equals(CreateAdvisorRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateAdvisorResponse
 */
export class CreateAdvisorResponse extends Message<CreateAdvisorResponse> {
  /**
   * @generated from field: protogen.Advisor advisor = 1;
   */
  advisor?: Advisor;

  constructor(data?: PartialMessage<CreateAdvisorResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateAdvisorResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisor", kind: "message", T: Advisor },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdvisorResponse {
    return new CreateAdvisorResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdvisorResponse {
    return new CreateAdvisorResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdvisorResponse {
    return new CreateAdvisorResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdvisorResponse | PlainMessage<CreateAdvisorResponse> | undefined, b: CreateAdvisorResponse | PlainMessage<CreateAdvisorResponse> | undefined): boolean {
    return proto3.util.equals(CreateAdvisorResponse, a, b);
  }
}

/**
 * @generated from message protogen.GenerateAdvisorContactsRequest
 */
export class GenerateAdvisorContactsRequest extends Message<GenerateAdvisorContactsRequest> {
  /**
   * @generated from field: string areaCode = 1;
   */
  areaCode = "";

  /**
   * @generated from field: string firstName = 2;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 3;
   */
  lastName = "";

  constructor(data?: PartialMessage<GenerateAdvisorContactsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GenerateAdvisorContactsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "areaCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateAdvisorContactsRequest {
    return new GenerateAdvisorContactsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateAdvisorContactsRequest {
    return new GenerateAdvisorContactsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateAdvisorContactsRequest {
    return new GenerateAdvisorContactsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateAdvisorContactsRequest | PlainMessage<GenerateAdvisorContactsRequest> | undefined, b: GenerateAdvisorContactsRequest | PlainMessage<GenerateAdvisorContactsRequest> | undefined): boolean {
    return proto3.util.equals(GenerateAdvisorContactsRequest, a, b);
  }
}

/**
 * @generated from message protogen.GenerateAdvisorContactsResponse
 */
export class GenerateAdvisorContactsResponse extends Message<GenerateAdvisorContactsResponse> {
  /**
   * @generated from field: string advisorEmail = 1;
   */
  advisorEmail = "";

  /**
   * @generated from field: string advisorPhone = 2;
   */
  advisorPhone = "";

  constructor(data?: PartialMessage<GenerateAdvisorContactsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GenerateAdvisorContactsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "advisorPhone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateAdvisorContactsResponse {
    return new GenerateAdvisorContactsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateAdvisorContactsResponse {
    return new GenerateAdvisorContactsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateAdvisorContactsResponse {
    return new GenerateAdvisorContactsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateAdvisorContactsResponse | PlainMessage<GenerateAdvisorContactsResponse> | undefined, b: GenerateAdvisorContactsResponse | PlainMessage<GenerateAdvisorContactsResponse> | undefined): boolean {
    return proto3.util.equals(GenerateAdvisorContactsResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateUserRolesRequest
 */
export class UpdateUserRolesRequest extends Message<UpdateUserRolesRequest> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  /**
   * @generated from field: repeated string roles = 2;
   */
  roles: string[] = [];

  constructor(data?: PartialMessage<UpdateUserRolesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateUserRolesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "roles", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserRolesRequest {
    return new UpdateUserRolesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserRolesRequest {
    return new UpdateUserRolesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserRolesRequest {
    return new UpdateUserRolesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateUserRolesRequest | PlainMessage<UpdateUserRolesRequest> | undefined, b: UpdateUserRolesRequest | PlainMessage<UpdateUserRolesRequest> | undefined): boolean {
    return proto3.util.equals(UpdateUserRolesRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateUserRolesResponse
 */
export class UpdateUserRolesResponse extends Message<UpdateUserRolesResponse> {
  /**
   * @generated from field: protogen.Advisor advisor = 1;
   */
  advisor?: Advisor;

  constructor(data?: PartialMessage<UpdateUserRolesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateUserRolesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisor", kind: "message", T: Advisor },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserRolesResponse {
    return new UpdateUserRolesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserRolesResponse {
    return new UpdateUserRolesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserRolesResponse {
    return new UpdateUserRolesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateUserRolesResponse | PlainMessage<UpdateUserRolesResponse> | undefined, b: UpdateUserRolesResponse | PlainMessage<UpdateUserRolesResponse> | undefined): boolean {
    return proto3.util.equals(UpdateUserRolesResponse, a, b);
  }
}

/**
 * @generated from message protogen.AuditRecord
 */
export class AuditRecord extends Message<AuditRecord> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string actorName = 2;
   */
  actorName = "";

  /**
   * @generated from field: string actorRef = 3;
   */
  actorRef = "";

  /**
   * @generated from field: string eventType = 4;
   */
  eventType = "";

  /**
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * @generated from field: string contextJson = 6;
   */
  contextJson = "";

  /**
   * @generated from field: int64 timestampSec = 7;
   */
  timestampSec = protoInt64.zero;

  constructor(data?: PartialMessage<AuditRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AuditRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "actorName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "actorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "eventType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "contextJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "timestampSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AuditRecord {
    return new AuditRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AuditRecord {
    return new AuditRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AuditRecord {
    return new AuditRecord().fromJsonString(jsonString, options);
  }

  static equals(a: AuditRecord | PlainMessage<AuditRecord> | undefined, b: AuditRecord | PlainMessage<AuditRecord> | undefined): boolean {
    return proto3.util.equals(AuditRecord, a, b);
  }
}

/**
 * @generated from message protogen.ListAuditRecordsRequest
 */
export class ListAuditRecordsRequest extends Message<ListAuditRecordsRequest> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  /**
   * @generated from field: string familyRef = 2;
   */
  familyRef = "";

  /**
   * @generated from field: string eventType = 3;
   */
  eventType = "";

  /**
   * @generated from field: int32 limit = 4;
   */
  limit = 0;

  constructor(data?: PartialMessage<ListAuditRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAuditRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "eventType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAuditRecordsRequest {
    return new ListAuditRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAuditRecordsRequest {
    return new ListAuditRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAuditRecordsRequest {
    return new ListAuditRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAuditRecordsRequest | PlainMessage<ListAuditRecordsRequest> | undefined, b: ListAuditRecordsRequest | PlainMessage<ListAuditRecordsRequest> | undefined): boolean {
    return proto3.util.equals(ListAuditRecordsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAuditRecordsResponse
 */
export class ListAuditRecordsResponse extends Message<ListAuditRecordsResponse> {
  /**
   * @generated from field: repeated protogen.AuditRecord records = 1;
   */
  records: AuditRecord[] = [];

  constructor(data?: PartialMessage<ListAuditRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAuditRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: AuditRecord, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAuditRecordsResponse {
    return new ListAuditRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAuditRecordsResponse {
    return new ListAuditRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAuditRecordsResponse {
    return new ListAuditRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAuditRecordsResponse | PlainMessage<ListAuditRecordsResponse> | undefined, b: ListAuditRecordsResponse | PlainMessage<ListAuditRecordsResponse> | undefined): boolean {
    return proto3.util.equals(ListAuditRecordsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAuditRecordTypesRequest
 */
export class ListAuditRecordTypesRequest extends Message<ListAuditRecordTypesRequest> {
  constructor(data?: PartialMessage<ListAuditRecordTypesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAuditRecordTypesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAuditRecordTypesRequest {
    return new ListAuditRecordTypesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAuditRecordTypesRequest {
    return new ListAuditRecordTypesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAuditRecordTypesRequest {
    return new ListAuditRecordTypesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAuditRecordTypesRequest | PlainMessage<ListAuditRecordTypesRequest> | undefined, b: ListAuditRecordTypesRequest | PlainMessage<ListAuditRecordTypesRequest> | undefined): boolean {
    return proto3.util.equals(ListAuditRecordTypesRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAuditRecordTypesResponse
 */
export class ListAuditRecordTypesResponse extends Message<ListAuditRecordTypesResponse> {
  /**
   * @generated from field: repeated string eventTypes = 1;
   */
  eventTypes: string[] = [];

  constructor(data?: PartialMessage<ListAuditRecordTypesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAuditRecordTypesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventTypes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAuditRecordTypesResponse {
    return new ListAuditRecordTypesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAuditRecordTypesResponse {
    return new ListAuditRecordTypesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAuditRecordTypesResponse {
    return new ListAuditRecordTypesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAuditRecordTypesResponse | PlainMessage<ListAuditRecordTypesResponse> | undefined, b: ListAuditRecordTypesResponse | PlainMessage<ListAuditRecordTypesResponse> | undefined): boolean {
    return proto3.util.equals(ListAuditRecordTypesResponse, a, b);
  }
}

/**
 * @generated from message protogen.ImpersonationRequest
 */
export class ImpersonationRequest extends Message<ImpersonationRequest> {
  /**
   * @generated from field: string username = 1;
   */
  username = "";

  constructor(data?: PartialMessage<ImpersonationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ImpersonationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImpersonationRequest {
    return new ImpersonationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImpersonationRequest {
    return new ImpersonationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImpersonationRequest {
    return new ImpersonationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImpersonationRequest | PlainMessage<ImpersonationRequest> | undefined, b: ImpersonationRequest | PlainMessage<ImpersonationRequest> | undefined): boolean {
    return proto3.util.equals(ImpersonationRequest, a, b);
  }
}

/**
 * @generated from message protogen.ImpersonationResponse
 */
export class ImpersonationResponse extends Message<ImpersonationResponse> {
  /**
   * @generated from field: string loginUrl = 1;
   */
  loginUrl = "";

  constructor(data?: PartialMessage<ImpersonationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ImpersonationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "loginUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImpersonationResponse {
    return new ImpersonationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImpersonationResponse {
    return new ImpersonationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImpersonationResponse {
    return new ImpersonationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImpersonationResponse | PlainMessage<ImpersonationResponse> | undefined, b: ImpersonationResponse | PlainMessage<ImpersonationResponse> | undefined): boolean {
    return proto3.util.equals(ImpersonationResponse, a, b);
  }
}

/**
 * @generated from message protogen.FamilyPlanUtilization
 */
export class FamilyPlanUtilization extends Message<FamilyPlanUtilization> {
  /**
   * @generated from field: string familyName = 1;
   */
  familyName = "";

  /**
   * @generated from field: protogen.PlanUtilization planUtilization = 2;
   */
  planUtilization?: PlanUtilization;

  constructor(data?: PartialMessage<FamilyPlanUtilization>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FamilyPlanUtilization";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "planUtilization", kind: "message", T: PlanUtilization },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FamilyPlanUtilization {
    return new FamilyPlanUtilization().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FamilyPlanUtilization {
    return new FamilyPlanUtilization().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FamilyPlanUtilization {
    return new FamilyPlanUtilization().fromJsonString(jsonString, options);
  }

  static equals(a: FamilyPlanUtilization | PlainMessage<FamilyPlanUtilization> | undefined, b: FamilyPlanUtilization | PlainMessage<FamilyPlanUtilization> | undefined): boolean {
    return proto3.util.equals(FamilyPlanUtilization, a, b);
  }
}

/**
 * @generated from message protogen.GetAllActiveFamilyPlanUtilizationRequest
 */
export class GetAllActiveFamilyPlanUtilizationRequest extends Message<GetAllActiveFamilyPlanUtilizationRequest> {
  constructor(data?: PartialMessage<GetAllActiveFamilyPlanUtilizationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAllActiveFamilyPlanUtilizationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAllActiveFamilyPlanUtilizationRequest {
    return new GetAllActiveFamilyPlanUtilizationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAllActiveFamilyPlanUtilizationRequest {
    return new GetAllActiveFamilyPlanUtilizationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAllActiveFamilyPlanUtilizationRequest {
    return new GetAllActiveFamilyPlanUtilizationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAllActiveFamilyPlanUtilizationRequest | PlainMessage<GetAllActiveFamilyPlanUtilizationRequest> | undefined, b: GetAllActiveFamilyPlanUtilizationRequest | PlainMessage<GetAllActiveFamilyPlanUtilizationRequest> | undefined): boolean {
    return proto3.util.equals(GetAllActiveFamilyPlanUtilizationRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAllActiveFamilyPlanUtilizationResponse
 */
export class GetAllActiveFamilyPlanUtilizationResponse extends Message<GetAllActiveFamilyPlanUtilizationResponse> {
  /**
   * @generated from field: repeated protogen.FamilyPlanUtilization familyPlanUtilization = 1;
   */
  familyPlanUtilization: FamilyPlanUtilization[] = [];

  constructor(data?: PartialMessage<GetAllActiveFamilyPlanUtilizationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAllActiveFamilyPlanUtilizationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyPlanUtilization", kind: "message", T: FamilyPlanUtilization, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAllActiveFamilyPlanUtilizationResponse {
    return new GetAllActiveFamilyPlanUtilizationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAllActiveFamilyPlanUtilizationResponse {
    return new GetAllActiveFamilyPlanUtilizationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAllActiveFamilyPlanUtilizationResponse {
    return new GetAllActiveFamilyPlanUtilizationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAllActiveFamilyPlanUtilizationResponse | PlainMessage<GetAllActiveFamilyPlanUtilizationResponse> | undefined, b: GetAllActiveFamilyPlanUtilizationResponse | PlainMessage<GetAllActiveFamilyPlanUtilizationResponse> | undefined): boolean {
    return proto3.util.equals(GetAllActiveFamilyPlanUtilizationResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateAdvisorAnnotationRequest
 */
export class CreateAdvisorAnnotationRequest extends Message<CreateAdvisorAnnotationRequest> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  /**
   * @generated from field: string applicationRef = 2;
   */
  applicationRef = "";

  /**
   * @generated from field: string content = 3;
   */
  content = "";

  /**
   * @generated from field: string textContent = 4;
   */
  textContent = "";

  /**
   * @generated from field: string contentType = 5;
   */
  contentType = "";

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 6;
   */
  attachments: UploadAttachment[] = [];

  /**
   * @generated from field: string noteType = 7;
   */
  noteType = "";

  /**
   * @generated from field: repeated string flags = 8;
   */
  flags: string[] = [];

  constructor(data?: PartialMessage<CreateAdvisorAnnotationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateAdvisorAnnotationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "applicationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "textContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "contentType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
    { no: 7, name: "noteType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "flags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdvisorAnnotationRequest {
    return new CreateAdvisorAnnotationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdvisorAnnotationRequest {
    return new CreateAdvisorAnnotationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdvisorAnnotationRequest {
    return new CreateAdvisorAnnotationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdvisorAnnotationRequest | PlainMessage<CreateAdvisorAnnotationRequest> | undefined, b: CreateAdvisorAnnotationRequest | PlainMessage<CreateAdvisorAnnotationRequest> | undefined): boolean {
    return proto3.util.equals(CreateAdvisorAnnotationRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateAdvisorAnnotationResponse
 */
export class CreateAdvisorAnnotationResponse extends Message<CreateAdvisorAnnotationResponse> {
  /**
   * @generated from field: protogen.AdvisorAnnotation annotation = 1;
   */
  annotation?: AdvisorAnnotation;

  constructor(data?: PartialMessage<CreateAdvisorAnnotationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateAdvisorAnnotationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "annotation", kind: "message", T: AdvisorAnnotation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdvisorAnnotationResponse {
    return new CreateAdvisorAnnotationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdvisorAnnotationResponse {
    return new CreateAdvisorAnnotationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdvisorAnnotationResponse {
    return new CreateAdvisorAnnotationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdvisorAnnotationResponse | PlainMessage<CreateAdvisorAnnotationResponse> | undefined, b: CreateAdvisorAnnotationResponse | PlainMessage<CreateAdvisorAnnotationResponse> | undefined): boolean {
    return proto3.util.equals(CreateAdvisorAnnotationResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAdvisorAnnotationsRequest
 */
export class ListAdvisorAnnotationsRequest extends Message<ListAdvisorAnnotationsRequest> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  /**
   * @generated from field: string applicationRef = 2;
   */
  applicationRef = "";

  /**
   * @generated from field: bool includeChangeEvents = 3;
   */
  includeChangeEvents = false;

  constructor(data?: PartialMessage<ListAdvisorAnnotationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorAnnotationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "applicationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "includeChangeEvents", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorAnnotationsRequest {
    return new ListAdvisorAnnotationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorAnnotationsRequest {
    return new ListAdvisorAnnotationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorAnnotationsRequest {
    return new ListAdvisorAnnotationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorAnnotationsRequest | PlainMessage<ListAdvisorAnnotationsRequest> | undefined, b: ListAdvisorAnnotationsRequest | PlainMessage<ListAdvisorAnnotationsRequest> | undefined): boolean {
    return proto3.util.equals(ListAdvisorAnnotationsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAdvisorAnnotationsResponse
 */
export class ListAdvisorAnnotationsResponse extends Message<ListAdvisorAnnotationsResponse> {
  /**
   * @generated from field: repeated protogen.AdvisorAnnotation annotations = 1;
   */
  annotations: AdvisorAnnotation[] = [];

  /**
   * @generated from field: repeated protogen.AdvisorChangeEventAnnotation changeEvents = 2;
   */
  changeEvents: AdvisorChangeEventAnnotation[] = [];

  constructor(data?: PartialMessage<ListAdvisorAnnotationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAdvisorAnnotationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "annotations", kind: "message", T: AdvisorAnnotation, repeated: true },
    { no: 2, name: "changeEvents", kind: "message", T: AdvisorChangeEventAnnotation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAdvisorAnnotationsResponse {
    return new ListAdvisorAnnotationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAdvisorAnnotationsResponse {
    return new ListAdvisorAnnotationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAdvisorAnnotationsResponse {
    return new ListAdvisorAnnotationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAdvisorAnnotationsResponse | PlainMessage<ListAdvisorAnnotationsResponse> | undefined, b: ListAdvisorAnnotationsResponse | PlainMessage<ListAdvisorAnnotationsResponse> | undefined): boolean {
    return proto3.util.equals(ListAdvisorAnnotationsResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAdvisorAnnotationRequest
 */
export class UpdateAdvisorAnnotationRequest extends Message<UpdateAdvisorAnnotationRequest> {
  /**
   * @generated from field: string annotationRef = 1;
   */
  annotationRef = "";

  /**
   * Later manage edits etc.
   *
   * @generated from field: bool delete = 2;
   */
  delete = false;

  constructor(data?: PartialMessage<UpdateAdvisorAnnotationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAdvisorAnnotationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "annotationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "delete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdvisorAnnotationRequest {
    return new UpdateAdvisorAnnotationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdvisorAnnotationRequest {
    return new UpdateAdvisorAnnotationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdvisorAnnotationRequest {
    return new UpdateAdvisorAnnotationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdvisorAnnotationRequest | PlainMessage<UpdateAdvisorAnnotationRequest> | undefined, b: UpdateAdvisorAnnotationRequest | PlainMessage<UpdateAdvisorAnnotationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAdvisorAnnotationRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAdvisorAnnotationResponse
 */
export class UpdateAdvisorAnnotationResponse extends Message<UpdateAdvisorAnnotationResponse> {
  /**
   * @generated from field: protogen.AdvisorAnnotation annotation = 1;
   */
  annotation?: AdvisorAnnotation;

  constructor(data?: PartialMessage<UpdateAdvisorAnnotationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAdvisorAnnotationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "annotation", kind: "message", T: AdvisorAnnotation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdvisorAnnotationResponse {
    return new UpdateAdvisorAnnotationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdvisorAnnotationResponse {
    return new UpdateAdvisorAnnotationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdvisorAnnotationResponse {
    return new UpdateAdvisorAnnotationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdvisorAnnotationResponse | PlainMessage<UpdateAdvisorAnnotationResponse> | undefined, b: UpdateAdvisorAnnotationResponse | PlainMessage<UpdateAdvisorAnnotationResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAdvisorAnnotationResponse, a, b);
  }
}

/**
 * @generated from message protogen.AddRematchAdvisorsRequest
 */
export class AddRematchAdvisorsRequest extends Message<AddRematchAdvisorsRequest> {
  /**
   * @generated from field: string rematchSessionRef = 1;
   */
  rematchSessionRef = "";

  /**
   * @generated from field: repeated string advisorRefs = 2;
   */
  advisorRefs: string[] = [];

  /**
   * @generated from field: int32 timeoutMinutes = 3;
   */
  timeoutMinutes = 0;

  constructor(data?: PartialMessage<AddRematchAdvisorsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AddRematchAdvisorsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rematchSessionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "advisorRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "timeoutMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddRematchAdvisorsRequest {
    return new AddRematchAdvisorsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddRematchAdvisorsRequest {
    return new AddRematchAdvisorsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddRematchAdvisorsRequest {
    return new AddRematchAdvisorsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddRematchAdvisorsRequest | PlainMessage<AddRematchAdvisorsRequest> | undefined, b: AddRematchAdvisorsRequest | PlainMessage<AddRematchAdvisorsRequest> | undefined): boolean {
    return proto3.util.equals(AddRematchAdvisorsRequest, a, b);
  }
}

/**
 * @generated from message protogen.AddRematchAdvisorsResponse
 */
export class AddRematchAdvisorsResponse extends Message<AddRematchAdvisorsResponse> {
  /**
   * @generated from field: int32 advisorsAdded = 1;
   */
  advisorsAdded = 0;

  /**
   * @generated from field: protogen.RematchSession session = 2;
   */
  session?: RematchSession;

  constructor(data?: PartialMessage<AddRematchAdvisorsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AddRematchAdvisorsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorsAdded", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "session", kind: "message", T: RematchSession },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddRematchAdvisorsResponse {
    return new AddRematchAdvisorsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddRematchAdvisorsResponse {
    return new AddRematchAdvisorsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddRematchAdvisorsResponse {
    return new AddRematchAdvisorsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AddRematchAdvisorsResponse | PlainMessage<AddRematchAdvisorsResponse> | undefined, b: AddRematchAdvisorsResponse | PlainMessage<AddRematchAdvisorsResponse> | undefined): boolean {
    return proto3.util.equals(AddRematchAdvisorsResponse, a, b);
  }
}

/**
 * @generated from message protogen.RemoveAdvisorFromEntityRequest
 */
export class RemoveAdvisorFromEntityRequest extends Message<RemoveAdvisorFromEntityRequest> {
  /**
   * @generated from field: string entityType = 1;
   */
  entityType = "";

  /**
   * @generated from field: string entityRef = 2;
   */
  entityRef = "";

  /**
   * @generated from field: string advisorRef = 3;
   */
  advisorRef = "";

  constructor(data?: PartialMessage<RemoveAdvisorFromEntityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RemoveAdvisorFromEntityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveAdvisorFromEntityRequest {
    return new RemoveAdvisorFromEntityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveAdvisorFromEntityRequest {
    return new RemoveAdvisorFromEntityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveAdvisorFromEntityRequest {
    return new RemoveAdvisorFromEntityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveAdvisorFromEntityRequest | PlainMessage<RemoveAdvisorFromEntityRequest> | undefined, b: RemoveAdvisorFromEntityRequest | PlainMessage<RemoveAdvisorFromEntityRequest> | undefined): boolean {
    return proto3.util.equals(RemoveAdvisorFromEntityRequest, a, b);
  }
}

/**
 * @generated from message protogen.RemoveAdvisorFromEntityResponse
 */
export class RemoveAdvisorFromEntityResponse extends Message<RemoveAdvisorFromEntityResponse> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<RemoveAdvisorFromEntityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RemoveAdvisorFromEntityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveAdvisorFromEntityResponse {
    return new RemoveAdvisorFromEntityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveAdvisorFromEntityResponse {
    return new RemoveAdvisorFromEntityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveAdvisorFromEntityResponse {
    return new RemoveAdvisorFromEntityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveAdvisorFromEntityResponse | PlainMessage<RemoveAdvisorFromEntityResponse> | undefined, b: RemoveAdvisorFromEntityResponse | PlainMessage<RemoveAdvisorFromEntityResponse> | undefined): boolean {
    return proto3.util.equals(RemoveAdvisorFromEntityResponse, a, b);
  }
}

/**
 * @generated from message protogen.ShareRematchOpportunitiesRequest
 */
export class ShareRematchOpportunitiesRequest extends Message<ShareRematchOpportunitiesRequest> {
  /**
   * @generated from field: string rematchSessionRef = 1;
   */
  rematchSessionRef = "";

  /**
   * @generated from field: int32 timeoutMinutes = 2;
   */
  timeoutMinutes = 0;

  constructor(data?: PartialMessage<ShareRematchOpportunitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ShareRematchOpportunitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rematchSessionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timeoutMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShareRematchOpportunitiesRequest {
    return new ShareRematchOpportunitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShareRematchOpportunitiesRequest {
    return new ShareRematchOpportunitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShareRematchOpportunitiesRequest {
    return new ShareRematchOpportunitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ShareRematchOpportunitiesRequest | PlainMessage<ShareRematchOpportunitiesRequest> | undefined, b: ShareRematchOpportunitiesRequest | PlainMessage<ShareRematchOpportunitiesRequest> | undefined): boolean {
    return proto3.util.equals(ShareRematchOpportunitiesRequest, a, b);
  }
}

/**
 * @generated from message protogen.ShareRematchOpportunitiesResponse
 */
export class ShareRematchOpportunitiesResponse extends Message<ShareRematchOpportunitiesResponse> {
  /**
   * @generated from field: protogen.RematchSession session = 1;
   */
  session?: RematchSession;

  constructor(data?: PartialMessage<ShareRematchOpportunitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ShareRematchOpportunitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "message", T: RematchSession },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShareRematchOpportunitiesResponse {
    return new ShareRematchOpportunitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShareRematchOpportunitiesResponse {
    return new ShareRematchOpportunitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShareRematchOpportunitiesResponse {
    return new ShareRematchOpportunitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ShareRematchOpportunitiesResponse | PlainMessage<ShareRematchOpportunitiesResponse> | undefined, b: ShareRematchOpportunitiesResponse | PlainMessage<ShareRematchOpportunitiesResponse> | undefined): boolean {
    return proto3.util.equals(ShareRematchOpportunitiesResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateRematchSessionRequest
 */
export class UpdateRematchSessionRequest extends Message<UpdateRematchSessionRequest> {
  /**
   * @generated from field: string rematchSessionRef = 1;
   */
  rematchSessionRef = "";

  /**
   * @generated from field: protogen.RematchSessionStatus status = 2;
   */
  status = RematchSessionStatus.REMATCH_STATUS_NOT_SET;

  /**
   * @generated from field: bool issueClientCredit = 3;
   */
  issueClientCredit = false;

  constructor(data?: PartialMessage<UpdateRematchSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateRematchSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rematchSessionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(RematchSessionStatus) },
    { no: 3, name: "issueClientCredit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRematchSessionRequest {
    return new UpdateRematchSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRematchSessionRequest {
    return new UpdateRematchSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRematchSessionRequest {
    return new UpdateRematchSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRematchSessionRequest | PlainMessage<UpdateRematchSessionRequest> | undefined, b: UpdateRematchSessionRequest | PlainMessage<UpdateRematchSessionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRematchSessionRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateRematchSessionResponse
 */
export class UpdateRematchSessionResponse extends Message<UpdateRematchSessionResponse> {
  /**
   * @generated from field: protogen.RematchSession session = 1;
   */
  session?: RematchSession;

  constructor(data?: PartialMessage<UpdateRematchSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateRematchSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "message", T: RematchSession },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRematchSessionResponse {
    return new UpdateRematchSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRematchSessionResponse {
    return new UpdateRematchSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRematchSessionResponse {
    return new UpdateRematchSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRematchSessionResponse | PlainMessage<UpdateRematchSessionResponse> | undefined, b: UpdateRematchSessionResponse | PlainMessage<UpdateRematchSessionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRematchSessionResponse, a, b);
  }
}

/**
 * @generated from message protogen.SetRematchScheduledSwitchRequest
 */
export class SetRematchScheduledSwitchRequest extends Message<SetRematchScheduledSwitchRequest> {
  /**
   * @generated from field: string rematchSessionRef = 1;
   */
  rematchSessionRef = "";

  /**
   * @generated from field: string advisorRef = 2;
   */
  advisorRef = "";

  /**
   * @generated from field: string switchDate = 3;
   */
  switchDate = "";

  constructor(data?: PartialMessage<SetRematchScheduledSwitchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SetRematchScheduledSwitchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rematchSessionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "switchDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetRematchScheduledSwitchRequest {
    return new SetRematchScheduledSwitchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetRematchScheduledSwitchRequest {
    return new SetRematchScheduledSwitchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetRematchScheduledSwitchRequest {
    return new SetRematchScheduledSwitchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetRematchScheduledSwitchRequest | PlainMessage<SetRematchScheduledSwitchRequest> | undefined, b: SetRematchScheduledSwitchRequest | PlainMessage<SetRematchScheduledSwitchRequest> | undefined): boolean {
    return proto3.util.equals(SetRematchScheduledSwitchRequest, a, b);
  }
}

/**
 * @generated from message protogen.SetRematchScheduledSwitchResponse
 */
export class SetRematchScheduledSwitchResponse extends Message<SetRematchScheduledSwitchResponse> {
  /**
   * @generated from field: protogen.RematchSession session = 1;
   */
  session?: RematchSession;

  constructor(data?: PartialMessage<SetRematchScheduledSwitchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SetRematchScheduledSwitchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "message", T: RematchSession },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetRematchScheduledSwitchResponse {
    return new SetRematchScheduledSwitchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetRematchScheduledSwitchResponse {
    return new SetRematchScheduledSwitchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetRematchScheduledSwitchResponse {
    return new SetRematchScheduledSwitchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetRematchScheduledSwitchResponse | PlainMessage<SetRematchScheduledSwitchResponse> | undefined, b: SetRematchScheduledSwitchResponse | PlainMessage<SetRematchScheduledSwitchResponse> | undefined): boolean {
    return proto3.util.equals(SetRematchScheduledSwitchResponse, a, b);
  }
}

/**
 * @generated from message protogen.ClearRematchScheduledSwitchRequest
 */
export class ClearRematchScheduledSwitchRequest extends Message<ClearRematchScheduledSwitchRequest> {
  /**
   * @generated from field: string rematchSessionRef = 1;
   */
  rematchSessionRef = "";

  constructor(data?: PartialMessage<ClearRematchScheduledSwitchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ClearRematchScheduledSwitchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rematchSessionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearRematchScheduledSwitchRequest {
    return new ClearRematchScheduledSwitchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearRematchScheduledSwitchRequest {
    return new ClearRematchScheduledSwitchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearRematchScheduledSwitchRequest {
    return new ClearRematchScheduledSwitchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClearRematchScheduledSwitchRequest | PlainMessage<ClearRematchScheduledSwitchRequest> | undefined, b: ClearRematchScheduledSwitchRequest | PlainMessage<ClearRematchScheduledSwitchRequest> | undefined): boolean {
    return proto3.util.equals(ClearRematchScheduledSwitchRequest, a, b);
  }
}

/**
 * @generated from message protogen.ClearRematchScheduledSwitchResponse
 */
export class ClearRematchScheduledSwitchResponse extends Message<ClearRematchScheduledSwitchResponse> {
  /**
   * @generated from field: protogen.RematchSession session = 1;
   */
  session?: RematchSession;

  constructor(data?: PartialMessage<ClearRematchScheduledSwitchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ClearRematchScheduledSwitchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "message", T: RematchSession },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearRematchScheduledSwitchResponse {
    return new ClearRematchScheduledSwitchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearRematchScheduledSwitchResponse {
    return new ClearRematchScheduledSwitchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearRematchScheduledSwitchResponse {
    return new ClearRematchScheduledSwitchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClearRematchScheduledSwitchResponse | PlainMessage<ClearRematchScheduledSwitchResponse> | undefined, b: ClearRematchScheduledSwitchResponse | PlainMessage<ClearRematchScheduledSwitchResponse> | undefined): boolean {
    return proto3.util.equals(ClearRematchScheduledSwitchResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAvailableBadgesRequest
 */
export class ListAvailableBadgesRequest extends Message<ListAvailableBadgesRequest> {
  constructor(data?: PartialMessage<ListAvailableBadgesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAvailableBadgesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableBadgesRequest {
    return new ListAvailableBadgesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableBadgesRequest {
    return new ListAvailableBadgesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableBadgesRequest {
    return new ListAvailableBadgesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableBadgesRequest | PlainMessage<ListAvailableBadgesRequest> | undefined, b: ListAvailableBadgesRequest | PlainMessage<ListAvailableBadgesRequest> | undefined): boolean {
    return proto3.util.equals(ListAvailableBadgesRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAvailableBadgesResponse
 */
export class ListAvailableBadgesResponse extends Message<ListAvailableBadgesResponse> {
  /**
   * @generated from field: repeated string badgeNames = 1;
   */
  badgeNames: string[] = [];

  constructor(data?: PartialMessage<ListAvailableBadgesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAvailableBadgesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "badgeNames", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAvailableBadgesResponse {
    return new ListAvailableBadgesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAvailableBadgesResponse {
    return new ListAvailableBadgesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAvailableBadgesResponse {
    return new ListAvailableBadgesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAvailableBadgesResponse | PlainMessage<ListAvailableBadgesResponse> | undefined, b: ListAvailableBadgesResponse | PlainMessage<ListAvailableBadgesResponse> | undefined): boolean {
    return proto3.util.equals(ListAvailableBadgesResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetUserBadgesRequest
 */
export class GetUserBadgesRequest extends Message<GetUserBadgesRequest> {
  /**
   * @generated from field: string userRef = 1;
   */
  userRef = "";

  constructor(data?: PartialMessage<GetUserBadgesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetUserBadgesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "userRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserBadgesRequest {
    return new GetUserBadgesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserBadgesRequest {
    return new GetUserBadgesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserBadgesRequest {
    return new GetUserBadgesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserBadgesRequest | PlainMessage<GetUserBadgesRequest> | undefined, b: GetUserBadgesRequest | PlainMessage<GetUserBadgesRequest> | undefined): boolean {
    return proto3.util.equals(GetUserBadgesRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetUserBadgesResponse
 */
export class GetUserBadgesResponse extends Message<GetUserBadgesResponse> {
  /**
   * @generated from field: repeated protogen.GetUserBadgesResponse.BadgeCount badges = 1;
   */
  badges: GetUserBadgesResponse_BadgeCount[] = [];

  constructor(data?: PartialMessage<GetUserBadgesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetUserBadgesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "badges", kind: "message", T: GetUserBadgesResponse_BadgeCount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserBadgesResponse {
    return new GetUserBadgesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserBadgesResponse {
    return new GetUserBadgesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserBadgesResponse {
    return new GetUserBadgesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserBadgesResponse | PlainMessage<GetUserBadgesResponse> | undefined, b: GetUserBadgesResponse | PlainMessage<GetUserBadgesResponse> | undefined): boolean {
    return proto3.util.equals(GetUserBadgesResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetUserBadgesResponse.BadgeCount
 */
export class GetUserBadgesResponse_BadgeCount extends Message<GetUserBadgesResponse_BadgeCount> {
  /**
   * @generated from field: string badgeName = 1;
   */
  badgeName = "";

  /**
   * @generated from field: int32 count = 2;
   */
  count = 0;

  constructor(data?: PartialMessage<GetUserBadgesResponse_BadgeCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetUserBadgesResponse.BadgeCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "badgeName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserBadgesResponse_BadgeCount {
    return new GetUserBadgesResponse_BadgeCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserBadgesResponse_BadgeCount {
    return new GetUserBadgesResponse_BadgeCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserBadgesResponse_BadgeCount {
    return new GetUserBadgesResponse_BadgeCount().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserBadgesResponse_BadgeCount | PlainMessage<GetUserBadgesResponse_BadgeCount> | undefined, b: GetUserBadgesResponse_BadgeCount | PlainMessage<GetUserBadgesResponse_BadgeCount> | undefined): boolean {
    return proto3.util.equals(GetUserBadgesResponse_BadgeCount, a, b);
  }
}

/**
 * @generated from message protogen.UpdateUserBadgeRequest
 */
export class UpdateUserBadgeRequest extends Message<UpdateUserBadgeRequest> {
  /**
   * @generated from field: string userRef = 1;
   */
  userRef = "";

  /**
   * @generated from field: string badgeName = 2;
   */
  badgeName = "";

  /**
   * @generated from field: bool increment = 3;
   */
  increment = false;

  constructor(data?: PartialMessage<UpdateUserBadgeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateUserBadgeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "userRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "badgeName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "increment", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserBadgeRequest {
    return new UpdateUserBadgeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserBadgeRequest {
    return new UpdateUserBadgeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserBadgeRequest {
    return new UpdateUserBadgeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateUserBadgeRequest | PlainMessage<UpdateUserBadgeRequest> | undefined, b: UpdateUserBadgeRequest | PlainMessage<UpdateUserBadgeRequest> | undefined): boolean {
    return proto3.util.equals(UpdateUserBadgeRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateUserBadgeResponse
 */
export class UpdateUserBadgeResponse extends Message<UpdateUserBadgeResponse> {
  /**
   * @generated from field: repeated protogen.UpdateUserBadgeResponse.BadgeCount badges = 1;
   */
  badges: UpdateUserBadgeResponse_BadgeCount[] = [];

  constructor(data?: PartialMessage<UpdateUserBadgeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateUserBadgeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "badges", kind: "message", T: UpdateUserBadgeResponse_BadgeCount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserBadgeResponse {
    return new UpdateUserBadgeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserBadgeResponse {
    return new UpdateUserBadgeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserBadgeResponse {
    return new UpdateUserBadgeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateUserBadgeResponse | PlainMessage<UpdateUserBadgeResponse> | undefined, b: UpdateUserBadgeResponse | PlainMessage<UpdateUserBadgeResponse> | undefined): boolean {
    return proto3.util.equals(UpdateUserBadgeResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateUserBadgeResponse.BadgeCount
 */
export class UpdateUserBadgeResponse_BadgeCount extends Message<UpdateUserBadgeResponse_BadgeCount> {
  /**
   * @generated from field: string badgeName = 1;
   */
  badgeName = "";

  /**
   * @generated from field: int32 count = 2;
   */
  count = 0;

  constructor(data?: PartialMessage<UpdateUserBadgeResponse_BadgeCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateUserBadgeResponse.BadgeCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "badgeName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateUserBadgeResponse_BadgeCount {
    return new UpdateUserBadgeResponse_BadgeCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateUserBadgeResponse_BadgeCount {
    return new UpdateUserBadgeResponse_BadgeCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateUserBadgeResponse_BadgeCount {
    return new UpdateUserBadgeResponse_BadgeCount().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateUserBadgeResponse_BadgeCount | PlainMessage<UpdateUserBadgeResponse_BadgeCount> | undefined, b: UpdateUserBadgeResponse_BadgeCount | PlainMessage<UpdateUserBadgeResponse_BadgeCount> | undefined): boolean {
    return proto3.util.equals(UpdateUserBadgeResponse_BadgeCount, a, b);
  }
}

/**
 * @generated from message protogen.ListUsersByBadgeRequest
 */
export class ListUsersByBadgeRequest extends Message<ListUsersByBadgeRequest> {
  /**
   * @generated from field: string badgeName = 1;
   */
  badgeName = "";

  constructor(data?: PartialMessage<ListUsersByBadgeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListUsersByBadgeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "badgeName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUsersByBadgeRequest {
    return new ListUsersByBadgeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUsersByBadgeRequest {
    return new ListUsersByBadgeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUsersByBadgeRequest {
    return new ListUsersByBadgeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListUsersByBadgeRequest | PlainMessage<ListUsersByBadgeRequest> | undefined, b: ListUsersByBadgeRequest | PlainMessage<ListUsersByBadgeRequest> | undefined): boolean {
    return proto3.util.equals(ListUsersByBadgeRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListUsersByBadgeResponse
 */
export class ListUsersByBadgeResponse extends Message<ListUsersByBadgeResponse> {
  /**
   * @generated from field: repeated protogen.ListUsersByBadgeResponse.UserBadge users = 1;
   */
  users: ListUsersByBadgeResponse_UserBadge[] = [];

  constructor(data?: PartialMessage<ListUsersByBadgeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListUsersByBadgeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "users", kind: "message", T: ListUsersByBadgeResponse_UserBadge, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUsersByBadgeResponse {
    return new ListUsersByBadgeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUsersByBadgeResponse {
    return new ListUsersByBadgeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUsersByBadgeResponse {
    return new ListUsersByBadgeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListUsersByBadgeResponse | PlainMessage<ListUsersByBadgeResponse> | undefined, b: ListUsersByBadgeResponse | PlainMessage<ListUsersByBadgeResponse> | undefined): boolean {
    return proto3.util.equals(ListUsersByBadgeResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListUsersByBadgeResponse.UserBadge
 */
export class ListUsersByBadgeResponse_UserBadge extends Message<ListUsersByBadgeResponse_UserBadge> {
  /**
   * @generated from field: protogen.AccountStub user = 1;
   */
  user?: AccountStub;

  /**
   * @generated from field: int32 count = 2;
   */
  count = 0;

  constructor(data?: PartialMessage<ListUsersByBadgeResponse_UserBadge>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListUsersByBadgeResponse.UserBadge";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: AccountStub },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUsersByBadgeResponse_UserBadge {
    return new ListUsersByBadgeResponse_UserBadge().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUsersByBadgeResponse_UserBadge {
    return new ListUsersByBadgeResponse_UserBadge().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUsersByBadgeResponse_UserBadge {
    return new ListUsersByBadgeResponse_UserBadge().fromJsonString(jsonString, options);
  }

  static equals(a: ListUsersByBadgeResponse_UserBadge | PlainMessage<ListUsersByBadgeResponse_UserBadge> | undefined, b: ListUsersByBadgeResponse_UserBadge | PlainMessage<ListUsersByBadgeResponse_UserBadge> | undefined): boolean {
    return proto3.util.equals(ListUsersByBadgeResponse_UserBadge, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateFeatureFlagRequest
 */
export class AdminUpdateFeatureFlagRequest extends Message<AdminUpdateFeatureFlagRequest> {
  /**
   * @generated from field: string userRef = 1;
   */
  userRef = "";

  /**
   * @generated from field: string flagName = 2;
   */
  flagName = "";

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled = false;

  constructor(data?: PartialMessage<AdminUpdateFeatureFlagRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateFeatureFlagRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "userRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "flagName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateFeatureFlagRequest {
    return new AdminUpdateFeatureFlagRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateFeatureFlagRequest {
    return new AdminUpdateFeatureFlagRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateFeatureFlagRequest {
    return new AdminUpdateFeatureFlagRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateFeatureFlagRequest | PlainMessage<AdminUpdateFeatureFlagRequest> | undefined, b: AdminUpdateFeatureFlagRequest | PlainMessage<AdminUpdateFeatureFlagRequest> | undefined): boolean {
    return proto3.util.equals(AdminUpdateFeatureFlagRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateFeatureFlagResponse
 */
export class AdminUpdateFeatureFlagResponse extends Message<AdminUpdateFeatureFlagResponse> {
  /**
   * @generated from field: repeated string enabledFeatureFlags = 1;
   */
  enabledFeatureFlags: string[] = [];

  constructor(data?: PartialMessage<AdminUpdateFeatureFlagResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateFeatureFlagResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabledFeatureFlags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateFeatureFlagResponse {
    return new AdminUpdateFeatureFlagResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateFeatureFlagResponse {
    return new AdminUpdateFeatureFlagResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateFeatureFlagResponse {
    return new AdminUpdateFeatureFlagResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateFeatureFlagResponse | PlainMessage<AdminUpdateFeatureFlagResponse> | undefined, b: AdminUpdateFeatureFlagResponse | PlainMessage<AdminUpdateFeatureFlagResponse> | undefined): boolean {
    return proto3.util.equals(AdminUpdateFeatureFlagResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateAdvisorServiceRequest
 */
export class AdminUpdateAdvisorServiceRequest extends Message<AdminUpdateAdvisorServiceRequest> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  /**
   * @generated from field: string serviceName = 2;
   */
  serviceName = "";

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled = false;

  /**
   * "notify", "browse", or empty for None
   *
   * @generated from field: string scope = 4;
   */
  scope = "";

  constructor(data?: PartialMessage<AdminUpdateAdvisorServiceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateAdvisorServiceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "serviceName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateAdvisorServiceRequest {
    return new AdminUpdateAdvisorServiceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateAdvisorServiceRequest {
    return new AdminUpdateAdvisorServiceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateAdvisorServiceRequest {
    return new AdminUpdateAdvisorServiceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateAdvisorServiceRequest | PlainMessage<AdminUpdateAdvisorServiceRequest> | undefined, b: AdminUpdateAdvisorServiceRequest | PlainMessage<AdminUpdateAdvisorServiceRequest> | undefined): boolean {
    return proto3.util.equals(AdminUpdateAdvisorServiceRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateAdvisorServiceResponse
 */
export class AdminUpdateAdvisorServiceResponse extends Message<AdminUpdateAdvisorServiceResponse> {
  /**
   * @generated from field: repeated string enabledServices = 1;
   */
  enabledServices: string[] = [];

  constructor(data?: PartialMessage<AdminUpdateAdvisorServiceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateAdvisorServiceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabledServices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateAdvisorServiceResponse {
    return new AdminUpdateAdvisorServiceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateAdvisorServiceResponse {
    return new AdminUpdateAdvisorServiceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateAdvisorServiceResponse {
    return new AdminUpdateAdvisorServiceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateAdvisorServiceResponse | PlainMessage<AdminUpdateAdvisorServiceResponse> | undefined, b: AdminUpdateAdvisorServiceResponse | PlainMessage<AdminUpdateAdvisorServiceResponse> | undefined): boolean {
    return proto3.util.equals(AdminUpdateAdvisorServiceResponse, a, b);
  }
}

/**
 * @generated from message protogen.EnsureCoreDocumentsRequest
 */
export class EnsureCoreDocumentsRequest extends Message<EnsureCoreDocumentsRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  constructor(data?: PartialMessage<EnsureCoreDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.EnsureCoreDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureCoreDocumentsRequest {
    return new EnsureCoreDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureCoreDocumentsRequest {
    return new EnsureCoreDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureCoreDocumentsRequest {
    return new EnsureCoreDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureCoreDocumentsRequest | PlainMessage<EnsureCoreDocumentsRequest> | undefined, b: EnsureCoreDocumentsRequest | PlainMessage<EnsureCoreDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(EnsureCoreDocumentsRequest, a, b);
  }
}

/**
 * @generated from message protogen.EnsureCoreDocumentsResponse
 */
export class EnsureCoreDocumentsResponse extends Message<EnsureCoreDocumentsResponse> {
  /**
   * @generated from field: repeated string createdTitles = 1;
   */
  createdTitles: string[] = [];

  /**
   * @generated from field: repeated string existingTitles = 2;
   */
  existingTitles: string[] = [];

  constructor(data?: PartialMessage<EnsureCoreDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.EnsureCoreDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "createdTitles", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "existingTitles", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureCoreDocumentsResponse {
    return new EnsureCoreDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureCoreDocumentsResponse {
    return new EnsureCoreDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureCoreDocumentsResponse {
    return new EnsureCoreDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureCoreDocumentsResponse | PlainMessage<EnsureCoreDocumentsResponse> | undefined, b: EnsureCoreDocumentsResponse | PlainMessage<EnsureCoreDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(EnsureCoreDocumentsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentThreadInstructionsRequest
 */
export class GetAgentThreadInstructionsRequest extends Message<GetAgentThreadInstructionsRequest> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<GetAgentThreadInstructionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentThreadInstructionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentThreadInstructionsRequest {
    return new GetAgentThreadInstructionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentThreadInstructionsRequest {
    return new GetAgentThreadInstructionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentThreadInstructionsRequest {
    return new GetAgentThreadInstructionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentThreadInstructionsRequest | PlainMessage<GetAgentThreadInstructionsRequest> | undefined, b: GetAgentThreadInstructionsRequest | PlainMessage<GetAgentThreadInstructionsRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentThreadInstructionsRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentThreadInstructionsResponse
 */
export class GetAgentThreadInstructionsResponse extends Message<GetAgentThreadInstructionsResponse> {
  /**
   * @generated from field: string instructions = 1;
   */
  instructions = "";

  constructor(data?: PartialMessage<GetAgentThreadInstructionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentThreadInstructionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentThreadInstructionsResponse {
    return new GetAgentThreadInstructionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentThreadInstructionsResponse {
    return new GetAgentThreadInstructionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentThreadInstructionsResponse {
    return new GetAgentThreadInstructionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentThreadInstructionsResponse | PlainMessage<GetAgentThreadInstructionsResponse> | undefined, b: GetAgentThreadInstructionsResponse | PlainMessage<GetAgentThreadInstructionsResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentThreadInstructionsResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminCreateAgentCronRequest
 */
export class AdminCreateAgentCronRequest extends Message<AdminCreateAgentCronRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string goal = 3;
   */
  goal = "";

  /**
   * ISO 8601 datetime for first run
   *
   * @generated from field: string firstRunAt = 4;
   */
  firstRunAt = "";

  /**
   * Optional recurring schedule
   *
   * @generated from field: string recurringUnit = 5;
   */
  recurringUnit = "";

  /**
   * @generated from field: int32 recurringInterval = 6;
   */
  recurringInterval = 0;

  /**
   * @generated from field: bool useUserTimezone = 7;
   */
  useUserTimezone = false;

  constructor(data?: PartialMessage<AdminCreateAgentCronRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminCreateAgentCronRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "firstRunAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "recurringUnit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "recurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "useUserTimezone", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminCreateAgentCronRequest {
    return new AdminCreateAgentCronRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminCreateAgentCronRequest {
    return new AdminCreateAgentCronRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminCreateAgentCronRequest {
    return new AdminCreateAgentCronRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminCreateAgentCronRequest | PlainMessage<AdminCreateAgentCronRequest> | undefined, b: AdminCreateAgentCronRequest | PlainMessage<AdminCreateAgentCronRequest> | undefined): boolean {
    return proto3.util.equals(AdminCreateAgentCronRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminCreateAgentCronResponse
 */
export class AdminCreateAgentCronResponse extends Message<AdminCreateAgentCronResponse> {
  /**
   * @generated from field: protogen.GetAccountBotDetailsResponse.AgentCron agentCron = 1;
   */
  agentCron?: GetAccountBotDetailsResponse_AgentCron;

  constructor(data?: PartialMessage<AdminCreateAgentCronResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminCreateAgentCronResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentCron", kind: "message", T: GetAccountBotDetailsResponse_AgentCron },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminCreateAgentCronResponse {
    return new AdminCreateAgentCronResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminCreateAgentCronResponse {
    return new AdminCreateAgentCronResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminCreateAgentCronResponse {
    return new AdminCreateAgentCronResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminCreateAgentCronResponse | PlainMessage<AdminCreateAgentCronResponse> | undefined, b: AdminCreateAgentCronResponse | PlainMessage<AdminCreateAgentCronResponse> | undefined): boolean {
    return proto3.util.equals(AdminCreateAgentCronResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateAgentCronRequest
 */
export class AdminUpdateAgentCronRequest extends Message<AdminUpdateAgentCronRequest> {
  /**
   * @generated from field: string agentCronRef = 1;
   */
  agentCronRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string goal = 3;
   */
  goal = "";

  /**
   * ISO 8601 datetime for next run
   *
   * @generated from field: string firstRunAt = 4;
   */
  firstRunAt = "";

  /**
   * Optional recurring schedule
   *
   * @generated from field: string recurringUnit = 5;
   */
  recurringUnit = "";

  /**
   * @generated from field: int32 recurringInterval = 6;
   */
  recurringInterval = 0;

  /**
   * @generated from field: bool useUserTimezone = 7;
   */
  useUserTimezone = false;

  /**
   * @generated from field: bool deactivate = 8;
   */
  deactivate = false;

  constructor(data?: PartialMessage<AdminUpdateAgentCronRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateAgentCronRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentCronRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "goal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "firstRunAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "recurringUnit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "recurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "useUserTimezone", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "deactivate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateAgentCronRequest {
    return new AdminUpdateAgentCronRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateAgentCronRequest {
    return new AdminUpdateAgentCronRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateAgentCronRequest {
    return new AdminUpdateAgentCronRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateAgentCronRequest | PlainMessage<AdminUpdateAgentCronRequest> | undefined, b: AdminUpdateAgentCronRequest | PlainMessage<AdminUpdateAgentCronRequest> | undefined): boolean {
    return proto3.util.equals(AdminUpdateAgentCronRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminUpdateAgentCronResponse
 */
export class AdminUpdateAgentCronResponse extends Message<AdminUpdateAgentCronResponse> {
  /**
   * @generated from field: protogen.GetAccountBotDetailsResponse.AgentCron agentCron = 1;
   */
  agentCron?: GetAccountBotDetailsResponse_AgentCron;

  constructor(data?: PartialMessage<AdminUpdateAgentCronResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminUpdateAgentCronResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentCron", kind: "message", T: GetAccountBotDetailsResponse_AgentCron },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminUpdateAgentCronResponse {
    return new AdminUpdateAgentCronResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminUpdateAgentCronResponse {
    return new AdminUpdateAgentCronResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminUpdateAgentCronResponse {
    return new AdminUpdateAgentCronResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminUpdateAgentCronResponse | PlainMessage<AdminUpdateAgentCronResponse> | undefined, b: AdminUpdateAgentCronResponse | PlainMessage<AdminUpdateAgentCronResponse> | undefined): boolean {
    return proto3.util.equals(AdminUpdateAgentCronResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsRequest
 */
export class GetAccountBotDetailsRequest extends Message<GetAccountBotDetailsRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  constructor(data?: PartialMessage<GetAccountBotDetailsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsRequest {
    return new GetAccountBotDetailsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsRequest {
    return new GetAccountBotDetailsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsRequest {
    return new GetAccountBotDetailsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsRequest | PlainMessage<GetAccountBotDetailsRequest> | undefined, b: GetAccountBotDetailsRequest | PlainMessage<GetAccountBotDetailsRequest> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse
 */
export class GetAccountBotDetailsResponse extends Message<GetAccountBotDetailsResponse> {
  /**
   * @generated from field: repeated protogen.GetAccountBotDetailsResponse.BotConversation conversations = 1;
   */
  conversations: GetAccountBotDetailsResponse_BotConversation[] = [];

  /**
   * @generated from field: repeated protogen.GetAccountBotDetailsResponse.AgentCron agentCrons = 2;
   */
  agentCrons: GetAccountBotDetailsResponse_AgentCron[] = [];

  /**
   * @generated from field: repeated protogen.GetAccountBotDetailsResponse.BotDocument botDocuments = 3;
   */
  botDocuments: GetAccountBotDetailsResponse_BotDocument[] = [];

  /**
   * @generated from field: repeated protogen.GetAccountBotDetailsResponse.BotTask botTasks = 4;
   */
  botTasks: GetAccountBotDetailsResponse_BotTask[] = [];

  /**
   * @generated from field: repeated protogen.GetAccountBotDetailsResponse.BotCalendarEvent botCalendarEvents = 5;
   */
  botCalendarEvents: GetAccountBotDetailsResponse_BotCalendarEvent[] = [];

  /**
   * @generated from field: repeated protogen.GetAccountBotDetailsResponse.BotDelegation botDelegations = 6;
   */
  botDelegations: GetAccountBotDetailsResponse_BotDelegation[] = [];

  /**
   * @generated from field: protogen.GetAccountBotDetailsResponse.TokenSummary tokenSummary = 7;
   */
  tokenSummary?: GetAccountBotDetailsResponse_TokenSummary;

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversations", kind: "message", T: GetAccountBotDetailsResponse_BotConversation, repeated: true },
    { no: 2, name: "agentCrons", kind: "message", T: GetAccountBotDetailsResponse_AgentCron, repeated: true },
    { no: 3, name: "botDocuments", kind: "message", T: GetAccountBotDetailsResponse_BotDocument, repeated: true },
    { no: 4, name: "botTasks", kind: "message", T: GetAccountBotDetailsResponse_BotTask, repeated: true },
    { no: 5, name: "botCalendarEvents", kind: "message", T: GetAccountBotDetailsResponse_BotCalendarEvent, repeated: true },
    { no: 6, name: "botDelegations", kind: "message", T: GetAccountBotDetailsResponse_BotDelegation, repeated: true },
    { no: 7, name: "tokenSummary", kind: "message", T: GetAccountBotDetailsResponse_TokenSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse {
    return new GetAccountBotDetailsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse {
    return new GetAccountBotDetailsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse {
    return new GetAccountBotDetailsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse | PlainMessage<GetAccountBotDetailsResponse> | undefined, b: GetAccountBotDetailsResponse | PlainMessage<GetAccountBotDetailsResponse> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.BotConversation
 */
export class GetAccountBotDetailsResponse_BotConversation extends Message<GetAccountBotDetailsResponse_BotConversation> {
  /**
   * @generated from field: string conversationRef = 1;
   */
  conversationRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: int64 lastUpdatedSec = 3;
   */
  lastUpdatedSec = protoInt64.zero;

  /**
   * @generated from field: int32 messageCount = 4;
   */
  messageCount = 0;

  /**
   * @generated from field: string medium = 5;
   */
  medium = "";

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_BotConversation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.BotConversation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "messageCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "medium", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_BotConversation {
    return new GetAccountBotDetailsResponse_BotConversation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotConversation {
    return new GetAccountBotDetailsResponse_BotConversation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotConversation {
    return new GetAccountBotDetailsResponse_BotConversation().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_BotConversation | PlainMessage<GetAccountBotDetailsResponse_BotConversation> | undefined, b: GetAccountBotDetailsResponse_BotConversation | PlainMessage<GetAccountBotDetailsResponse_BotConversation> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_BotConversation, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.AgentCron
 */
export class GetAccountBotDetailsResponse_AgentCron extends Message<GetAccountBotDetailsResponse_AgentCron> {
  /**
   * @generated from field: string agentCronRef = 1;
   */
  agentCronRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: int64 lastUpdatedSec = 3;
   */
  lastUpdatedSec = protoInt64.zero;

  /**
   * @generated from field: string scheduleSummary = 4;
   */
  scheduleSummary = "";

  /**
   * @generated from field: string agentThreadRef = 5;
   */
  agentThreadRef = "";

  /**
   * @generated from field: string conversationRef = 6;
   */
  conversationRef = "";

  /**
   * @generated from field: int32 executionCount = 7;
   */
  executionCount = 0;

  /**
   * @generated from field: string status = 8;
   */
  status = "";

  /**
   * @generated from field: string goal = 9;
   */
  goal = "";

  /**
   * @generated from field: repeated protogen.GetAccountBotDetailsResponse.AgentCron.Execution executions = 10;
   */
  executions: GetAccountBotDetailsResponse_AgentCron_Execution[] = [];

  /**
   * @generated from field: string cronType = 11;
   */
  cronType = "";

  /**
   * @generated from field: string recurringUnit = 12;
   */
  recurringUnit = "";

  /**
   * @generated from field: int32 recurringInterval = 13;
   */
  recurringInterval = 0;

  /**
   * @generated from field: int64 nextRunSec = 14;
   */
  nextRunSec = protoInt64.zero;

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_AgentCron>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.AgentCron";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentCronRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "scheduleSummary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "executionCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "goal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "executions", kind: "message", T: GetAccountBotDetailsResponse_AgentCron_Execution, repeated: true },
    { no: 11, name: "cronType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "recurringUnit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "recurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "nextRunSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_AgentCron {
    return new GetAccountBotDetailsResponse_AgentCron().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_AgentCron {
    return new GetAccountBotDetailsResponse_AgentCron().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_AgentCron {
    return new GetAccountBotDetailsResponse_AgentCron().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_AgentCron | PlainMessage<GetAccountBotDetailsResponse_AgentCron> | undefined, b: GetAccountBotDetailsResponse_AgentCron | PlainMessage<GetAccountBotDetailsResponse_AgentCron> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_AgentCron, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.AgentCron.Execution
 */
export class GetAccountBotDetailsResponse_AgentCron_Execution extends Message<GetAccountBotDetailsResponse_AgentCron_Execution> {
  /**
   * @generated from field: string agentThreadRef = 1;
   */
  agentThreadRef = "";

  /**
   * @generated from field: int64 createdSec = 2;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_AgentCron_Execution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.AgentCron.Execution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_AgentCron_Execution {
    return new GetAccountBotDetailsResponse_AgentCron_Execution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_AgentCron_Execution {
    return new GetAccountBotDetailsResponse_AgentCron_Execution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_AgentCron_Execution {
    return new GetAccountBotDetailsResponse_AgentCron_Execution().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_AgentCron_Execution | PlainMessage<GetAccountBotDetailsResponse_AgentCron_Execution> | undefined, b: GetAccountBotDetailsResponse_AgentCron_Execution | PlainMessage<GetAccountBotDetailsResponse_AgentCron_Execution> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_AgentCron_Execution, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.BotDocument
 */
export class GetAccountBotDetailsResponse_BotDocument extends Message<GetAccountBotDetailsResponse_BotDocument> {
  /**
   * @generated from field: string documentRef = 1;
   */
  documentRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: int64 lastUpdatedSec = 3;
   */
  lastUpdatedSec = protoInt64.zero;

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_BotDocument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.BotDocument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documentRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_BotDocument {
    return new GetAccountBotDetailsResponse_BotDocument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotDocument {
    return new GetAccountBotDetailsResponse_BotDocument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotDocument {
    return new GetAccountBotDetailsResponse_BotDocument().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_BotDocument | PlainMessage<GetAccountBotDetailsResponse_BotDocument> | undefined, b: GetAccountBotDetailsResponse_BotDocument | PlainMessage<GetAccountBotDetailsResponse_BotDocument> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_BotDocument, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.BotTask
 */
export class GetAccountBotDetailsResponse_BotTask extends Message<GetAccountBotDetailsResponse_BotTask> {
  /**
   * @generated from field: string taskRef = 1;
   */
  taskRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string state = 3;
   */
  state = "";

  /**
   * @generated from field: string priority = 4;
   */
  priority = "";

  /**
   * @generated from field: int64 createdSec = 5;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: string agentThreadRef = 6;
   */
  agentThreadRef = "";

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_BotTask>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.BotTask";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "taskRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "priority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_BotTask {
    return new GetAccountBotDetailsResponse_BotTask().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotTask {
    return new GetAccountBotDetailsResponse_BotTask().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotTask {
    return new GetAccountBotDetailsResponse_BotTask().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_BotTask | PlainMessage<GetAccountBotDetailsResponse_BotTask> | undefined, b: GetAccountBotDetailsResponse_BotTask | PlainMessage<GetAccountBotDetailsResponse_BotTask> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_BotTask, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.BotCalendarEvent
 */
export class GetAccountBotDetailsResponse_BotCalendarEvent extends Message<GetAccountBotDetailsResponse_BotCalendarEvent> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: int64 startSec = 3;
   */
  startSec = protoInt64.zero;

  /**
   * @generated from field: int64 createdSec = 4;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: string agentThreadRef = 5;
   */
  agentThreadRef = "";

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_BotCalendarEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.BotCalendarEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "startSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_BotCalendarEvent {
    return new GetAccountBotDetailsResponse_BotCalendarEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotCalendarEvent {
    return new GetAccountBotDetailsResponse_BotCalendarEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotCalendarEvent {
    return new GetAccountBotDetailsResponse_BotCalendarEvent().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_BotCalendarEvent | PlainMessage<GetAccountBotDetailsResponse_BotCalendarEvent> | undefined, b: GetAccountBotDetailsResponse_BotCalendarEvent | PlainMessage<GetAccountBotDetailsResponse_BotCalendarEvent> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_BotCalendarEvent, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.BotDelegation
 */
export class GetAccountBotDetailsResponse_BotDelegation extends Message<GetAccountBotDetailsResponse_BotDelegation> {
  /**
   * @generated from field: string delegationRef = 1;
   */
  delegationRef = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: string serviceType = 4;
   */
  serviceType = "";

  /**
   * @generated from field: int64 createdSec = 5;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: string taskRef = 6;
   */
  taskRef = "";

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_BotDelegation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.BotDelegation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "delegationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "serviceType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "taskRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_BotDelegation {
    return new GetAccountBotDetailsResponse_BotDelegation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotDelegation {
    return new GetAccountBotDetailsResponse_BotDelegation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_BotDelegation {
    return new GetAccountBotDetailsResponse_BotDelegation().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_BotDelegation | PlainMessage<GetAccountBotDetailsResponse_BotDelegation> | undefined, b: GetAccountBotDetailsResponse_BotDelegation | PlainMessage<GetAccountBotDetailsResponse_BotDelegation> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_BotDelegation, a, b);
  }
}

/**
 * @generated from message protogen.GetAccountBotDetailsResponse.TokenSummary
 */
export class GetAccountBotDetailsResponse_TokenSummary extends Message<GetAccountBotDetailsResponse_TokenSummary> {
  /**
   * @generated from field: int64 inputTokens = 1;
   */
  inputTokens = protoInt64.zero;

  /**
   * @generated from field: int64 outputTokens = 2;
   */
  outputTokens = protoInt64.zero;

  /**
   * @generated from field: int64 cacheCreationTokens = 3;
   */
  cacheCreationTokens = protoInt64.zero;

  /**
   * @generated from field: int64 cacheReadTokens = 4;
   */
  cacheReadTokens = protoInt64.zero;

  /**
   * @generated from field: double estimatedCostUsd = 5;
   */
  estimatedCostUsd = 0;

  /**
   * @generated from field: double inputCostUsd = 6;
   */
  inputCostUsd = 0;

  /**
   * @generated from field: double outputCostUsd = 7;
   */
  outputCostUsd = 0;

  /**
   * @generated from field: double cacheCreationCostUsd = 8;
   */
  cacheCreationCostUsd = 0;

  /**
   * @generated from field: double cacheReadCostUsd = 9;
   */
  cacheReadCostUsd = 0;

  /**
   * @generated from field: int32 executionCount30d = 10;
   */
  executionCount30d = 0;

  /**
   * @generated from field: double avgTokensPerExecution30d = 11;
   */
  avgTokensPerExecution30d = 0;

  /**
   * @generated from field: double avgExecutionsPerThread30d = 12;
   */
  avgExecutionsPerThread30d = 0;

  /**
   * @generated from field: int64 imageInputTokens = 13;
   */
  imageInputTokens = protoInt64.zero;

  /**
   * @generated from field: int64 imageOutputTokens = 14;
   */
  imageOutputTokens = protoInt64.zero;

  /**
   * @generated from field: double imageInputCostUsd = 15;
   */
  imageInputCostUsd = 0;

  /**
   * @generated from field: double imageOutputCostUsd = 16;
   */
  imageOutputCostUsd = 0;

  constructor(data?: PartialMessage<GetAccountBotDetailsResponse_TokenSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAccountBotDetailsResponse.TokenSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inputTokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "outputTokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "cacheCreationTokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "cacheReadTokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "estimatedCostUsd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "inputCostUsd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "outputCostUsd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "cacheCreationCostUsd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "cacheReadCostUsd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "executionCount30d", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "avgTokensPerExecution30d", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "avgExecutionsPerThread30d", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "imageInputTokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "imageOutputTokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 15, name: "imageInputCostUsd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "imageOutputCostUsd", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAccountBotDetailsResponse_TokenSummary {
    return new GetAccountBotDetailsResponse_TokenSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_TokenSummary {
    return new GetAccountBotDetailsResponse_TokenSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAccountBotDetailsResponse_TokenSummary {
    return new GetAccountBotDetailsResponse_TokenSummary().fromJsonString(jsonString, options);
  }

  static equals(a: GetAccountBotDetailsResponse_TokenSummary | PlainMessage<GetAccountBotDetailsResponse_TokenSummary> | undefined, b: GetAccountBotDetailsResponse_TokenSummary | PlainMessage<GetAccountBotDetailsResponse_TokenSummary> | undefined): boolean {
    return proto3.util.equals(GetAccountBotDetailsResponse_TokenSummary, a, b);
  }
}

/**
 * @generated from message protogen.DigitalSubscriptionPlaybook
 */
export class DigitalSubscriptionPlaybook extends Message<DigitalSubscriptionPlaybook> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: string contentHtml = 4;
   */
  contentHtml = "";

  /**
   * @generated from field: int64 createdSec = 5;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: int64 updatedSec = 6;
   */
  updatedSec = protoInt64.zero;

  /**
   * @generated from field: repeated protogen.Attachment attachments = 7;
   */
  attachments: Attachment[] = [];

  constructor(data?: PartialMessage<DigitalSubscriptionPlaybook>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DigitalSubscriptionPlaybook";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "contentHtml", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "updatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "attachments", kind: "message", T: Attachment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DigitalSubscriptionPlaybook {
    return new DigitalSubscriptionPlaybook().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DigitalSubscriptionPlaybook {
    return new DigitalSubscriptionPlaybook().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DigitalSubscriptionPlaybook {
    return new DigitalSubscriptionPlaybook().fromJsonString(jsonString, options);
  }

  static equals(a: DigitalSubscriptionPlaybook | PlainMessage<DigitalSubscriptionPlaybook> | undefined, b: DigitalSubscriptionPlaybook | PlainMessage<DigitalSubscriptionPlaybook> | undefined): boolean {
    return proto3.util.equals(DigitalSubscriptionPlaybook, a, b);
  }
}

/**
 * @generated from message protogen.ListDigitalSubscriptionPlaybooksRequest
 */
export class ListDigitalSubscriptionPlaybooksRequest extends Message<ListDigitalSubscriptionPlaybooksRequest> {
  constructor(data?: PartialMessage<ListDigitalSubscriptionPlaybooksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDigitalSubscriptionPlaybooksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDigitalSubscriptionPlaybooksRequest {
    return new ListDigitalSubscriptionPlaybooksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionPlaybooksRequest {
    return new ListDigitalSubscriptionPlaybooksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionPlaybooksRequest {
    return new ListDigitalSubscriptionPlaybooksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDigitalSubscriptionPlaybooksRequest | PlainMessage<ListDigitalSubscriptionPlaybooksRequest> | undefined, b: ListDigitalSubscriptionPlaybooksRequest | PlainMessage<ListDigitalSubscriptionPlaybooksRequest> | undefined): boolean {
    return proto3.util.equals(ListDigitalSubscriptionPlaybooksRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListDigitalSubscriptionPlaybooksResponse
 */
export class ListDigitalSubscriptionPlaybooksResponse extends Message<ListDigitalSubscriptionPlaybooksResponse> {
  /**
   * @generated from field: repeated protogen.DigitalSubscriptionPlaybook playbooks = 1;
   */
  playbooks: DigitalSubscriptionPlaybook[] = [];

  constructor(data?: PartialMessage<ListDigitalSubscriptionPlaybooksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListDigitalSubscriptionPlaybooksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "playbooks", kind: "message", T: DigitalSubscriptionPlaybook, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDigitalSubscriptionPlaybooksResponse {
    return new ListDigitalSubscriptionPlaybooksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionPlaybooksResponse {
    return new ListDigitalSubscriptionPlaybooksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDigitalSubscriptionPlaybooksResponse {
    return new ListDigitalSubscriptionPlaybooksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDigitalSubscriptionPlaybooksResponse | PlainMessage<ListDigitalSubscriptionPlaybooksResponse> | undefined, b: ListDigitalSubscriptionPlaybooksResponse | PlainMessage<ListDigitalSubscriptionPlaybooksResponse> | undefined): boolean {
    return proto3.util.equals(ListDigitalSubscriptionPlaybooksResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateDigitalSubscriptionPlaybookRequest
 */
export class CreateDigitalSubscriptionPlaybookRequest extends Message<CreateDigitalSubscriptionPlaybookRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string contentHtml = 3;
   */
  contentHtml = "";

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 4;
   */
  attachments: UploadAttachment[] = [];

  constructor(data?: PartialMessage<CreateDigitalSubscriptionPlaybookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateDigitalSubscriptionPlaybookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "contentHtml", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDigitalSubscriptionPlaybookRequest {
    return new CreateDigitalSubscriptionPlaybookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDigitalSubscriptionPlaybookRequest {
    return new CreateDigitalSubscriptionPlaybookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDigitalSubscriptionPlaybookRequest {
    return new CreateDigitalSubscriptionPlaybookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDigitalSubscriptionPlaybookRequest | PlainMessage<CreateDigitalSubscriptionPlaybookRequest> | undefined, b: CreateDigitalSubscriptionPlaybookRequest | PlainMessage<CreateDigitalSubscriptionPlaybookRequest> | undefined): boolean {
    return proto3.util.equals(CreateDigitalSubscriptionPlaybookRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateDigitalSubscriptionPlaybookResponse
 */
export class CreateDigitalSubscriptionPlaybookResponse extends Message<CreateDigitalSubscriptionPlaybookResponse> {
  /**
   * @generated from field: protogen.DigitalSubscriptionPlaybook playbook = 1;
   */
  playbook?: DigitalSubscriptionPlaybook;

  constructor(data?: PartialMessage<CreateDigitalSubscriptionPlaybookResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateDigitalSubscriptionPlaybookResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "playbook", kind: "message", T: DigitalSubscriptionPlaybook },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDigitalSubscriptionPlaybookResponse {
    return new CreateDigitalSubscriptionPlaybookResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDigitalSubscriptionPlaybookResponse {
    return new CreateDigitalSubscriptionPlaybookResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDigitalSubscriptionPlaybookResponse {
    return new CreateDigitalSubscriptionPlaybookResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDigitalSubscriptionPlaybookResponse | PlainMessage<CreateDigitalSubscriptionPlaybookResponse> | undefined, b: CreateDigitalSubscriptionPlaybookResponse | PlainMessage<CreateDigitalSubscriptionPlaybookResponse> | undefined): boolean {
    return proto3.util.equals(CreateDigitalSubscriptionPlaybookResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDigitalSubscriptionPlaybookRequest
 */
export class UpdateDigitalSubscriptionPlaybookRequest extends Message<UpdateDigitalSubscriptionPlaybookRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: string contentHtml = 4;
   */
  contentHtml = "";

  /**
   * @generated from field: bool deleted = 5;
   */
  deleted = false;

  /**
   * @generated from field: repeated protogen.UploadAttachment attachments = 6;
   */
  attachments: UploadAttachment[] = [];

  constructor(data?: PartialMessage<UpdateDigitalSubscriptionPlaybookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDigitalSubscriptionPlaybookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "contentHtml", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "attachments", kind: "message", T: UploadAttachment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDigitalSubscriptionPlaybookRequest {
    return new UpdateDigitalSubscriptionPlaybookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDigitalSubscriptionPlaybookRequest {
    return new UpdateDigitalSubscriptionPlaybookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDigitalSubscriptionPlaybookRequest {
    return new UpdateDigitalSubscriptionPlaybookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDigitalSubscriptionPlaybookRequest | PlainMessage<UpdateDigitalSubscriptionPlaybookRequest> | undefined, b: UpdateDigitalSubscriptionPlaybookRequest | PlainMessage<UpdateDigitalSubscriptionPlaybookRequest> | undefined): boolean {
    return proto3.util.equals(UpdateDigitalSubscriptionPlaybookRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateDigitalSubscriptionPlaybookResponse
 */
export class UpdateDigitalSubscriptionPlaybookResponse extends Message<UpdateDigitalSubscriptionPlaybookResponse> {
  /**
   * @generated from field: protogen.DigitalSubscriptionPlaybook playbook = 1;
   */
  playbook?: DigitalSubscriptionPlaybook;

  constructor(data?: PartialMessage<UpdateDigitalSubscriptionPlaybookResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateDigitalSubscriptionPlaybookResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "playbook", kind: "message", T: DigitalSubscriptionPlaybook },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateDigitalSubscriptionPlaybookResponse {
    return new UpdateDigitalSubscriptionPlaybookResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateDigitalSubscriptionPlaybookResponse {
    return new UpdateDigitalSubscriptionPlaybookResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateDigitalSubscriptionPlaybookResponse {
    return new UpdateDigitalSubscriptionPlaybookResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateDigitalSubscriptionPlaybookResponse | PlainMessage<UpdateDigitalSubscriptionPlaybookResponse> | undefined, b: UpdateDigitalSubscriptionPlaybookResponse | PlainMessage<UpdateDigitalSubscriptionPlaybookResponse> | undefined): boolean {
    return proto3.util.equals(UpdateDigitalSubscriptionPlaybookResponse, a, b);
  }
}

/**
 * @generated from message protogen.ExportFamilyDataRequest
 */
export class ExportFamilyDataRequest extends Message<ExportFamilyDataRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  constructor(data?: PartialMessage<ExportFamilyDataRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ExportFamilyDataRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportFamilyDataRequest {
    return new ExportFamilyDataRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportFamilyDataRequest {
    return new ExportFamilyDataRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportFamilyDataRequest {
    return new ExportFamilyDataRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExportFamilyDataRequest | PlainMessage<ExportFamilyDataRequest> | undefined, b: ExportFamilyDataRequest | PlainMessage<ExportFamilyDataRequest> | undefined): boolean {
    return proto3.util.equals(ExportFamilyDataRequest, a, b);
  }
}

/**
 * @generated from message protogen.ExportFamilyDataResponse
 */
export class ExportFamilyDataResponse extends Message<ExportFamilyDataResponse> {
  constructor(data?: PartialMessage<ExportFamilyDataResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ExportFamilyDataResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportFamilyDataResponse {
    return new ExportFamilyDataResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportFamilyDataResponse {
    return new ExportFamilyDataResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportFamilyDataResponse {
    return new ExportFamilyDataResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExportFamilyDataResponse | PlainMessage<ExportFamilyDataResponse> | undefined, b: ExportFamilyDataResponse | PlainMessage<ExportFamilyDataResponse> | undefined): boolean {
    return proto3.util.equals(ExportFamilyDataResponse, a, b);
  }
}

/**
 * Diagnoses a phone/email that is "already in use": one person can hold accounts of several
 * types over time, so a single value can be claimed by more than one of them at once.
 *
 * @generated from message protogen.AdminLookupIdentityRequest
 */
export class AdminLookupIdentityRequest extends Message<AdminLookupIdentityRequest> {
  /**
   * A phone number, an email address, or a user id.
   *
   * @generated from field: string query = 1;
   */
  query = "";

  constructor(data?: PartialMessage<AdminLookupIdentityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminLookupIdentityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminLookupIdentityRequest {
    return new AdminLookupIdentityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminLookupIdentityRequest {
    return new AdminLookupIdentityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminLookupIdentityRequest {
    return new AdminLookupIdentityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminLookupIdentityRequest | PlainMessage<AdminLookupIdentityRequest> | undefined, b: AdminLookupIdentityRequest | PlainMessage<AdminLookupIdentityRequest> | undefined): boolean {
    return proto3.util.equals(AdminLookupIdentityRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminLookupIdentityResponse
 */
export class AdminLookupIdentityResponse extends Message<AdminLookupIdentityResponse> {
  /**
   * Every account holding the queried value. More than one means a live collision.
   *
   * @generated from field: repeated protogen.AdminLookupIdentityResponse.Account accounts = 1;
   */
  accounts: AdminLookupIdentityResponse_Account[] = [];

  /**
   * NUX rows claim invitee_email independently of any account, so they are reported
   * separately -- one can exist with no account attached at all.
   *
   * @generated from field: repeated protogen.AdminLookupIdentityResponse.NuxEntry nuxEntries = 2;
   */
  nuxEntries: AdminLookupIdentityResponse_NuxEntry[] = [];

  /**
   * @generated from field: string resolvedQueryType = 3;
   */
  resolvedQueryType = "";

  constructor(data?: PartialMessage<AdminLookupIdentityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminLookupIdentityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accounts", kind: "message", T: AdminLookupIdentityResponse_Account, repeated: true },
    { no: 2, name: "nuxEntries", kind: "message", T: AdminLookupIdentityResponse_NuxEntry, repeated: true },
    { no: 3, name: "resolvedQueryType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminLookupIdentityResponse {
    return new AdminLookupIdentityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse {
    return new AdminLookupIdentityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse {
    return new AdminLookupIdentityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminLookupIdentityResponse | PlainMessage<AdminLookupIdentityResponse> | undefined, b: AdminLookupIdentityResponse | PlainMessage<AdminLookupIdentityResponse> | undefined): boolean {
    return proto3.util.equals(AdminLookupIdentityResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminLookupIdentityResponse.Conversation
 */
export class AdminLookupIdentityResponse_Conversation extends Message<AdminLookupIdentityResponse_Conversation> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string medium = 2;
   */
  medium = "";

  /**
   * @generated from field: string inboxType = 3;
   */
  inboxType = "";

  /**
   * @generated from field: int64 inboxEntityId = 4;
   */
  inboxEntityId = protoInt64.zero;

  /**
   * @generated from field: int32 messageCount = 5;
   */
  messageCount = 0;

  /**
   * @generated from field: int64 lastUpdatedSecUTC = 6;
   */
  lastUpdatedSecUTC = protoInt64.zero;

  /**
   * @generated from field: repeated protogen.AccountStub participants = 7;
   */
  participants: AccountStub[] = [];

  constructor(data?: PartialMessage<AdminLookupIdentityResponse_Conversation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminLookupIdentityResponse.Conversation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "medium", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "inboxType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "inboxEntityId", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "messageCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "lastUpdatedSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "participants", kind: "message", T: AccountStub, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminLookupIdentityResponse_Conversation {
    return new AdminLookupIdentityResponse_Conversation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse_Conversation {
    return new AdminLookupIdentityResponse_Conversation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse_Conversation {
    return new AdminLookupIdentityResponse_Conversation().fromJsonString(jsonString, options);
  }

  static equals(a: AdminLookupIdentityResponse_Conversation | PlainMessage<AdminLookupIdentityResponse_Conversation> | undefined, b: AdminLookupIdentityResponse_Conversation | PlainMessage<AdminLookupIdentityResponse_Conversation> | undefined): boolean {
    return proto3.util.equals(AdminLookupIdentityResponse_Conversation, a, b);
  }
}

/**
 * @generated from message protogen.AdminLookupIdentityResponse.NuxEntry
 */
export class AdminLookupIdentityResponse_NuxEntry extends Message<AdminLookupIdentityResponse_NuxEntry> {
  /**
   * @generated from field: string inviteeEmail = 1;
   */
  inviteeEmail = "";

  /**
   * @generated from field: string stepName = 2;
   */
  stepName = "";

  /**
   * @generated from field: int64 creationDateSecUTC = 3;
   */
  creationDateSecUTC = protoInt64.zero;

  /**
   * Empty when the NUX was never linked to an account.
   *
   * @generated from field: string userRef = 4;
   */
  userRef = "";

  constructor(data?: PartialMessage<AdminLookupIdentityResponse_NuxEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminLookupIdentityResponse.NuxEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inviteeEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stepName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creationDateSecUTC", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "userRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminLookupIdentityResponse_NuxEntry {
    return new AdminLookupIdentityResponse_NuxEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse_NuxEntry {
    return new AdminLookupIdentityResponse_NuxEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse_NuxEntry {
    return new AdminLookupIdentityResponse_NuxEntry().fromJsonString(jsonString, options);
  }

  static equals(a: AdminLookupIdentityResponse_NuxEntry | PlainMessage<AdminLookupIdentityResponse_NuxEntry> | undefined, b: AdminLookupIdentityResponse_NuxEntry | PlainMessage<AdminLookupIdentityResponse_NuxEntry> | undefined): boolean {
    return proto3.util.equals(AdminLookupIdentityResponse_NuxEntry, a, b);
  }
}

/**
 * @generated from message protogen.AdminLookupIdentityResponse.Account
 */
export class AdminLookupIdentityResponse_Account extends Message<AdminLookupIdentityResponse_Account> {
  /**
   * @generated from field: protogen.AccountStub stub = 1;
   */
  stub?: AccountStub;

  /**
   * @generated from field: int64 userId = 2;
   */
  userId = protoInt64.zero;

  /**
   * @generated from field: string username = 3;
   */
  username = "";

  /**
   * @generated from field: string phone = 4;
   */
  phone = "";

  /**
   * @generated from field: string email = 5;
   */
  email = "";

  /**
   * Credentials frozen by a retirement or deactivation.
   *
   * @generated from field: bool isRetired = 6;
   */
  isRetired = false;

  /**
   * @generated from field: string familyName = 7;
   */
  familyName = "";

  /**
   * @generated from field: string familyStatus = 8;
   */
  familyStatus = "";

  /**
   * Members only -- links to the family admin page where their identity is freed.
   *
   * @generated from field: string familyRef = 13;
   */
  familyRef = "";

  /**
   * External contacts only.
   *
   * @generated from field: string addedByName = 9;
   */
  addedByName = "";

  /**
   * Which of the queried values this account holds: "phone" and/or "email".
   *
   * @generated from field: repeated string claimedFields = 10;
   */
  claimedFields: string[] = [];

  /**
   * @generated from field: repeated protogen.AdminLookupIdentityResponse.Conversation conversations = 11;
   */
  conversations: AdminLookupIdentityResponse_Conversation[] = [];

  /**
   * Advisors only.
   *
   * @generated from field: string advisorStatus = 12;
   */
  advisorStatus = "";

  constructor(data?: PartialMessage<AdminLookupIdentityResponse_Account>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminLookupIdentityResponse.Account";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stub", kind: "message", T: AccountStub },
    { no: 2, name: "userId", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "isRetired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "familyName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "familyStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "addedByName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "claimedFields", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "conversations", kind: "message", T: AdminLookupIdentityResponse_Conversation, repeated: true },
    { no: 12, name: "advisorStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminLookupIdentityResponse_Account {
    return new AdminLookupIdentityResponse_Account().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse_Account {
    return new AdminLookupIdentityResponse_Account().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminLookupIdentityResponse_Account {
    return new AdminLookupIdentityResponse_Account().fromJsonString(jsonString, options);
  }

  static equals(a: AdminLookupIdentityResponse_Account | PlainMessage<AdminLookupIdentityResponse_Account> | undefined, b: AdminLookupIdentityResponse_Account | PlainMessage<AdminLookupIdentityResponse_Account> | undefined): boolean {
    return proto3.util.equals(AdminLookupIdentityResponse_Account, a, b);
  }
}

/**
 * Frees a deactivated account's phone/email/invitee-email for reuse by tagging the
 * unique-constrained identity columns. Only allowed for accounts that are already inactive:
 * a deactivated advisor, a member of a deactivated family, or an external contact.
 *
 * @generated from message protogen.AdminDeactivateIdentityRequest
 */
export class AdminDeactivateIdentityRequest extends Message<AdminDeactivateIdentityRequest> {
  /**
   * @generated from field: string userRef = 1;
   */
  userRef = "";

  constructor(data?: PartialMessage<AdminDeactivateIdentityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminDeactivateIdentityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "userRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDeactivateIdentityRequest {
    return new AdminDeactivateIdentityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDeactivateIdentityRequest {
    return new AdminDeactivateIdentityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDeactivateIdentityRequest {
    return new AdminDeactivateIdentityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDeactivateIdentityRequest | PlainMessage<AdminDeactivateIdentityRequest> | undefined, b: AdminDeactivateIdentityRequest | PlainMessage<AdminDeactivateIdentityRequest> | undefined): boolean {
    return proto3.util.equals(AdminDeactivateIdentityRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminDeactivateIdentityResponse
 */
export class AdminDeactivateIdentityResponse extends Message<AdminDeactivateIdentityResponse> {
  /**
   * @generated from field: protogen.AdminLookupIdentityResponse.Account account = 1;
   */
  account?: AdminLookupIdentityResponse_Account;

  constructor(data?: PartialMessage<AdminDeactivateIdentityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminDeactivateIdentityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "account", kind: "message", T: AdminLookupIdentityResponse_Account },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminDeactivateIdentityResponse {
    return new AdminDeactivateIdentityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminDeactivateIdentityResponse {
    return new AdminDeactivateIdentityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminDeactivateIdentityResponse {
    return new AdminDeactivateIdentityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminDeactivateIdentityResponse | PlainMessage<AdminDeactivateIdentityResponse> | undefined, b: AdminDeactivateIdentityResponse | PlainMessage<AdminDeactivateIdentityResponse> | undefined): boolean {
    return proto3.util.equals(AdminDeactivateIdentityResponse, a, b);
  }
}

